import { BillingAddOnComponent } from '../billing-add-on/billing-add-on.component';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  ChangeDetectorRef,
  Inject,
  LOCALE_ID,
  OnDestroy,
} from '@angular/core';
import { ButtonModule } from 'primeng/button';
import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
  AbstractControl,
} from '@angular/forms';

import { DrawerModule } from 'primeng/drawer';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { SelectModule } from 'primeng/select';
import { TooltipModule } from 'primeng/tooltip';
import { DividerModule } from 'primeng/divider';
import { DatePickerModule } from 'primeng/datepicker';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CommonModule, getCurrencySymbol } from '@angular/common';
import { InputMaskModule } from 'primeng/inputmask';
import {
  AddonBreakUpResponse,
  ChargeBreakUp,
  ChargingToday,
  ChargingTodaySignUp,
  Claim,
  ClaimConstant,
  Client,
  CLientReferralResponse,
  Crm,
  Deposit,
  EligibleCoupons,
  GetPlanMasterByIdResponse,
  GetPlanMasterListResponse,
  MidCycleAddonBreakupRequest,
  NonRecurringBreakUp,
  OfferMaster,
  OverLappingSubscriptionSignUpResponse,
  PaymentGatewatMaster,
  PaymentSignUp,
  PlanAddons,
  PlanBreakUpCalculation,
  PlanBreakUpCalculationRequest,
  PlanBreakUpCalculationResponse,
  PlanMasterList,
  PlanMasterServices,
  PlanSummary,
  PosDeviceDetails,
  PosDeviceSale,
  RecurringBreakUp,
  RecurringSignUp,
  RecurringTemplateRecurringService,
  RetailProduct,
  ServiceBreakUp,
  ServiceFirstCharge,
  SignUpRequest,
  SignUpResponse,
  StaffDiscountCalculationRequest,
  StaffDiscountChargeRecurring,
  StaffDiscountChargingTodayRequest,
  StaffDiscountDespositRequest,
  StaffDiscountServiceFirstChargeRequest,
  StaffDiscountServiceNonRecurringRequest,
  StaffDiscountServiceRecurringRequest,
  StaffDiscountSignUpChargeRequest,
  STAFFINTERFACE,
  SubscriptionById,
  TaxLineItemBreakUp,
  TenantById,
  TENANTSINTERFACE,
  UpgradePlanBreakUpRequest,
  UpgradeSignUpRequest,
  ValidationError,
} from '@fitness-force/models';
import { BehaviorSubject, catchError, combineLatestWith, distinctUntilChanged, map, Observable, of, retryWhen, scan, switchMap, throwError, timer, Subscription, combineLatest, tap, Subject, debounceTime } from 'rxjs';
import {
  AdvancedSettingService,
  AuthSevices,
  ClaimService,
  ClientService,
  CommonService,
  CouponService,
  PaymentGatewayMasterService,
  PlanmasterService,
  PlansubscriptionService,
  TenantService,
  TimeconversionService,
  ToastMessageService,
  UpgradeService,
} from '@fitness-force/api';
import {
  AppErrors,
  NotFoundError,
  ErrorMsgComponent,
} from '@fitness-force/errors';
import {
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import { ErrorsComponent, } from '@fitness-force/common/errors'
import { AssignedToComponent } from '@fitness-force/common/assigned-to'
import { MiniSearchComponent, } from '@fitness-force/common/search';
import {
  ClientReferralStatus,
  ComplitionTargetDevice,
  PaymentGatewaySupported,
  PlanCategory,
  PlanIntervalType,
  PlanType,
  Roles,
  ServiceBehaviour,
  SignUpMode,
  Status,
} from '@fitness-force/enum';
import {
  COUNTRY_MASTER_STATE,
  STAFF_STATE,
  TENANTS_INFO,
  TENANT_STATE,
} from 'apps/ff-frontend/src/app/state/app.state';
import { Store } from '@ngrx/store';
import { SkeletonModule } from 'primeng/skeleton';
import { InputNumberModule } from 'primeng/inputnumber';
import { CurrencyformatPipe } from '@fitness-force/pipes/currency';
import { StyleClassModule } from 'primeng/styleclass';
import { InputTextModule } from 'primeng/inputtext';
import { DialogModule } from 'primeng/dialog';
import { MessageModule } from 'primeng/message';
import { PopoverModule } from 'primeng/popover';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { CheckboxModule } from 'primeng/checkbox';
import Statsig from 'statsig-js';
import { OtherPaymentComponent } from '@fitness-force/common/payment';
import { ChangeSessionOwnerComponent } from '../change-session-owner/change-session-owner.component';
import { BillingClientInfoComponent } from '../billing-client-info/billing-client-info.component';
import { UpgradeMembershipInfoComponent } from '../upgrade-membership-info/upgrade-membership-info.component';
import { CONSTANTS_DATA } from '@fitness-force/constants';
import { PosDeviceListComponent } from '../pos-device-list/pos-device-list.component';
import { RouteStateService } from '@fitness-force/shared';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TableModule } from 'primeng/table';
import { InputNumberComponent } from 'libs/shared/src/lib/components/input-number/input-number.component';
import { TagModule } from 'primeng/tag';
import { ConfirmationService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';

@Component({
  selector: 'billing-summary',
  templateUrl: './billing-summary.component.html',
  styleUrls: ['./billing-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  providers: [DialogService],
  imports: [
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    InputNumberModule,
    ButtonModule,
    DrawerModule,
    AvatarModule,
    AvatarGroupModule,
    SelectModule,
    DividerModule,
    DatePickerModule,
    RadioButtonModule,
    MessageModule,
    CommonModule,
    SkeletonModule,
    CurrencyformatPipe,
    AssignedToComponent,
    ErrorsComponent,
    ErrorMsgComponent,
    StyleClassModule,
    InputTextModule,
    InputMaskModule,
    DialogModule,
    MiniSearchComponent,
    PopoverModule,
    AutoCompleteModule,
    ScrollPanelModule,
    CheckboxModule,
    OtherPaymentComponent,
    ChangeSessionOwnerComponent,
    BillingClientInfoComponent,
    UpgradeMembershipInfoComponent,
    BillingAddOnComponent,
    PosDeviceListComponent,
    ProgressSpinnerModule,
    TooltipModule,
    TableModule,
    TagModule,
    InputNumberComponent,
    TranslateModule
]
})

export class BillingSummaryComponent implements OnInit, OnDestroy {
  @Input('visible') showPaidFullSidebar = false;
  @Input('planSummarydata') planSummary$!: Observable<PlanSummary>;
  @Input() isCartFlow: boolean= false;
  @Output() addToCart: EventEmitter<{type:string; object:any}> = new EventEmitter();
  @Output() hideSidePopup: EventEmitter<{ hideSidebar: boolean; clientSignupUUID: string; }> = new EventEmitter();
  @Output() closeSidePopup: EventEmitter<{ hideSidebar: boolean; clientSignupUUID: string; }> = new EventEmitter();

  disablePlanDropdown = false;
  getAccessTenantList$!: Observable<any>;
  tenantId = 0;
  billedAtTenantId = 0;
  subscriptionPlanId = 0;
  fromSubscriptionPlanId = 0;
  clientId = 0;
  clientName = '';
  isInclusive = false;
  keyFobRequired = false;
  isContract$ = new BehaviorSubject<boolean>(false);
  isCashRecurring = false;
  billing_interval_type$ = new BehaviorSubject<string>('');
  billing_interval_value$ = new BehaviorSubject<number>(0);
  subscription_category$ = new BehaviorSubject<string>('');
  bill_cycle_day!: string;
  fg: UntypedFormGroup = new UntypedFormGroup({});
  planIntervalType = PlanIntervalType;
  planCategory = PlanType;
  maxStartDate :Date | undefined;
  minStartDate :Date = new Date();
  isSubmitting = new BehaviorSubject<boolean>(false);
  errMsg: Error | any;
  error = new BehaviorSubject(null as AppErrors | null);
  boolshowSessionOwner = false;
  changeBillingName = false;
  claim$: Observable<Claim[]> = new Observable();
  monthNames: string[] = CONSTANTS_DATA.MONTHS;
  fgProducts: UntypedFormGroup = new UntypedFormGroup({
    frmFirstTimeBaseCostAmt: new UntypedFormControl(''),
    frmFirstTimeAmt: new UntypedFormControl('', [Validators.required]),
    frmFirstTimeDis: new UntypedFormControl('', [Validators.required]),
    frmFirstTimeTaxAmt: new UntypedFormControl('', []),
    frmNonRecurringBaseCostAmt: new UntypedFormControl(''),
    frmNonRecurringAmt: new UntypedFormControl('', [Validators.required]),
    frmNonRecurringDis: new UntypedFormControl('', [Validators.required]),
    frmNonRecurringTaxAmt: new UntypedFormControl('', []),
    charges: new UntypedFormArray([]),
    charges_reason: new UntypedFormControl('', [Validators.maxLength(1500)]),
    deposits: new UntypedFormArray([]),
    products: new UntypedFormArray([]),
  });
  fgProductsRecurring: UntypedFormGroup = new UntypedFormGroup({
    frmRecurringMembershipBaseCostAmt: new UntypedFormControl('', []),
    frmRecurringMembershipAmt: new UntypedFormControl('', []),
    frmRecurringMembershipDis: new UntypedFormControl('', []),
    frmRecurringMembershipTaxAmt: new UntypedFormControl('', []),
    recurring_reason: new UntypedFormControl('', [Validators.maxLength(1500)]),
  });
  userDiscountLimit = 0;
  single_staff_discount = 0;
  recurring_staff_discount = 0;
  planDetail$: Observable<GetPlanMasterByIdResponse> = new Observable();
  billingCycleOption$ = new BehaviorSubject<any[]>([]);
  countryCode = "";
  totalNonRecurringAmt$ = new BehaviorSubject(0);
  _selectedstaff = new BehaviorSubject<number>(0);
  _filterStaff = new BehaviorSubject<number[]>([0]);
  isCoupounEnabled: boolean = false;
  isTaxInClusive: boolean = false;
  weekDays: string[] = CONSTANTS_DATA.DAYS;
  billOwnerId$ = new BehaviorSubject<number>(0);
  planBreakUpCalculationResponse$ = new BehaviorSubject<PlanBreakUpCalculationResponse>(null!);
  overLappingSubscriptionSignUp$ = new BehaviorSubject<OverLappingSubscriptionSignUpResponse>(null!);
  planBreakUpCalculation$: BehaviorSubject<PlanBreakUpCalculation | null> = new BehaviorSubject<PlanBreakUpCalculation | null>(null);
  planSubscription$: BehaviorSubject<PlanMasterList[] | null> = new BehaviorSubject<PlanMasterList[] | null>(null);
  upgradePlanBreakUpCalculationResponse$ = new BehaviorSubject<PlanBreakUpCalculationResponse>(null!);
  midCycleAddonBreakUpCalculationResponse$ = new BehaviorSubject<AddonBreakUpResponse>(null!);
  clientSignupUUID: string = '';
  selectedMembership: | { name: string; duration: string; amount: string } | undefined;
  startDate: Date | undefined;
  // Variables used in controls

  applyDiscount: boolean = false;
  applyCoupon: boolean = false;
  couponApplied: boolean = false;
  discountApplied: boolean = false;
  inValidDiscount: boolean = false;
  inValidRecurringDiscount: boolean = false;
  onlinePayment: boolean = false;


  showErrorPopup = new BehaviorSubject(false);
  errorMessages = [] as any;
  errorDataModal = [] as ValidationError[];
  currentUserDetails: any;
  inValidCoupon = new BehaviorSubject(false);
  alreadyDiscountApplied = new BehaviorSubject(false);
  referredBy: number = 0;
  tenantDetails: TenantById = {} as TenantById;
  clientKeyfob: any = '';
  //validAlphaNumericPattern = "^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$";
  validAlphaNumericPattern = "^[a-zA-Z0-9]*$";

  clientData: any;
  couponCollection!: any[];
  applyCouponModal: boolean = false;
  couponCode: string = "";
  creditBalance: number = 0;
  currencySymbol$ = new BehaviorSubject<string>('');
  errorOnCouponApply: boolean = false;
  planDetail: GetPlanMasterByIdResponse = {} as GetPlanMasterByIdResponse;
  selectedPlanDetail$ = new BehaviorSubject<GetPlanMasterByIdResponse>({} as GetPlanMasterByIdResponse);
  currentLoggedinUser: any;

  showSkeleton$ = new BehaviorSubject<boolean>(true);
  showSkeletonForBillDetails$ = new BehaviorSubject<boolean>(true);

  showOtherPaymentsModel$ = new BehaviorSubject<boolean>(false);
  showSessionOwnerChangeModel$ = new BehaviorSubject<boolean>(false);
  showChangeBillingNameModel$ = new BehaviorSubject<boolean>(false);
  paymentAmount: number = 0;
  billingName: string = "";
  isCouponApplied = new BehaviorSubject<boolean>(false);
  isDiscountApplied = new BehaviorSubject<boolean>(false);
  billingSignupMode: SignUpMode = SignUpMode.SignUp;
  fromSubscription: SubscriptionById = {} as SubscriptionById;
  isOverlapping: boolean = false;
  isPlanSelected: boolean = false;
  planSummary: PlanSummary = {} as PlanSummary;
  requestParams = new Map();
  showAddonsSidebar: boolean = false;
  showDeviceList: boolean = false;

  digitalKeyFOBSelected: boolean = false;
  physicalKeyFOBSelected: boolean = false;
  selectedAddons = new BehaviorSubject<PlanAddons[]>([]);

  signups: any[];
  selectedSignUp: { name: string } | undefined;

  posDeviceList = new BehaviorSubject<PosDeviceDetails[]>([]);
  paymentGatewayList = new BehaviorSubject<PaymentGatewatMaster[]>([]);
  paymentGateway: PaymentGatewatMaster = {} as PaymentGatewatMaster;
  posDeviceSale: PosDeviceSale | undefined;

  paymentFailed: boolean = false;
  transactionInProcess: boolean = false;

  disablePosButton = new BehaviorSubject<boolean>(true);

  CompilationTargets = Object.entries(ComplitionTargetDevice)
    .filter((key) => typeof key[1] != 'number')
    .map(([key, value]) => ({ key, value }));

  showChargeOnPosTerminal = new BehaviorSubject(false);
  showSIgnupComplition = new BehaviorSubject(false);
  showAddonBilling = new BehaviorSubject(false);
  showDigitalKeyFob = new BehaviorSubject(false);
  changeEvent: string = "";
  subsStartDateValue: any;
  billingDateValue: any;
  tableLoading = new BehaviorSubject(false);
  subsStartDate: Date = new Date();
  isPresaleTenant = new BehaviorSubject<boolean>(false);

  private subscriptions = new Subscription(); // Add this as a class property
  public referredByClientId: number = 0;
  private clientReferrals: CLientReferralResponse = {} as CLientReferralResponse;
  applyDiscountBtnLoading: boolean = false;

  // Keyfob validation properties
  isValidatingKeyfob: boolean = false;
  isKeyfobValid: boolean = false;
  keyfobValidationMessage: string = '';

  private keyfobValidationSubscription!: Subscription;

  maxSubscriptionStartDate = new Date();

  isStartDateChanged: boolean = false;

  constructor(
    private fb: UntypedFormBuilder,
    private store: Store,
    private translate: TranslateService,
    private clientService: ClientService,
    private planmasterService: PlanmasterService,
    private plansubscriptionService: PlansubscriptionService,
    public authService: AuthSevices,
    private timeService: TimeconversionService,
    private advanceSettingService: AdvancedSettingService,
    private claimService: ClaimService,
    private toastMessageService: ToastMessageService,
    public cd: ChangeDetectorRef,
    public commonService: CommonService,
    private couponService: CouponService,
    private upgradeService: UpgradeService,
    private tenantService: TenantService,
    private paymentGatewayMasterService: PaymentGatewayMasterService,
    private stateService: RouteStateService,
    public confirmationService: ConfirmationService,
    @Inject(LOCALE_ID) public locale: string
  ) {
    this.signups = [
      { name: 'iPad' },
      { name: 'Clients Phone' }
  ];
    this.componentInit();
    this.SetFormFields();
  }

  ngOnInit(): void {
    this.maxStartDate = new Date();
    this.planSummary$.subscribe(async (plan: PlanSummary) => {
      this.planSummary = plan;
      this.tenantId = plan.tenant_id;
      this.clientId = plan.client.client_id;
      this.clientName = plan.client.client_name;
      this.billingName = plan.billingName || '';
      this.subscriptionPlanId = plan.id;
      this.fromSubscriptionPlanId = plan.from_subscription_id;
      this.billingSignupMode = plan.SignUpMode ? plan.SignUpMode : SignUpMode.SignUp;
      this.setSubscriptionStartDate(plan);
      this.CheckPresaleTenant();
      this.getSettings();
      this.getClientDetails();
      this.getClientCreditBalance();
      this.filterStaff();
      if (this.subscriptionPlanId == 0) {
        this.BindPlanList(plan.tenant_id);
        this.isPlanSelected = false;
        this.disablePlanDropdown = true;
      }
      else {
        this.isPlanSelected = true;
        this.disablePlanDropdown = false;
      }
      if (this.subscriptionPlanId > 0) this.GetEligibleCoupons();

      if (this.billingSignupMode == SignUpMode.MidCycleAddons || this.billingSignupMode.toString() == SignUpMode[SignUpMode.MidCycleAddons]) {
        this.selectedAddons.next(plan.addons!);
      }

      if ((this.billingSignupMode == SignUpMode.Upgrade || this.billingSignupMode.toString() == SignUpMode[SignUpMode.Upgrade])
        || (this.billingSignupMode == SignUpMode.MidCycleAddons || this.billingSignupMode.toString() == SignUpMode[SignUpMode.MidCycleAddons])) {
        this.getFromSubscription(plan.from_subscription_id, plan.client.client_id);
      }
      await this.timeout(400);
      this.BindPlanById(plan.tenant_id, plan.id, plan.client.client_id);
    });
    this._selectedstaff.next(Number(this.authService.loggedInStaffId));
    this.currentLoggedinUser = this.authService.currentUserDetails();
    
  }

  componentInit() {
    // Group related observables
    const tenantSubscription = this.store.select(TENANTS_INFO).pipe(
      tap((tenant: TENANTSINTERFACE) => {
        this.tenantId = tenant.selected_tenant.id;
        this.countryCode = tenant.selected_tenant.country;
        this.billedAtTenantId = this.tenantId;
        if (this.tenantId > 0) {
          this.store.dispatch({ type: 'ROUTER_GO' });

        }
      })
    );

    const featureFlags = {
      chargeOnPos: Statsig.checkGate("show_charge_on_terminal_or_pos"),
      signupCompletion: Statsig.checkGate("show_signup_completion_on_tablet_app"),
      addonBilling: Statsig.checkGate("show_addons_billing"),
      digitalKeyFob: Statsig.checkGate("show_digital_keyfob")
    };

    // Update feature flags
    this.showChargeOnPosTerminal.next(featureFlags.chargeOnPos);
    this.showSIgnupComplition.next(featureFlags.signupCompletion);
    this.showAddonBilling.next(true); // Note: Always true despite feature flag
    this.showDigitalKeyFob.next(featureFlags.digitalKeyFob);

    // Handle digital key fob selection
    if (featureFlags.digitalKeyFob) {
      this.physicalKeyFOBSelected = false;
    } else {
      this.physicalKeyFOBSelected = true;
    }

    // Configure translations and currency
    this.subscriptions.add(
      this.store.select(COUNTRY_MASTER_STATE).subscribe((country) => {
        this.currencySymbol$.next(
          getCurrencySymbol(country.currency_code, 'narrow', this.locale)
        );
      })
    );

    // Initialize current user details and permissions
    this.currentUserDetails = this.authService.decodedToken;
    this.single_staff_discount = this.currentUserDetails.single_staff_discount;
    this.recurring_staff_discount = this.currentUserDetails.recurring_staff_discount;

    // Combine all tenant related subscriptions
    this.subscriptions.add(
      combineLatest([
        this.store.select(TENANTS_INFO),
        tenantSubscription
      ]).subscribe()
    );

    // Initialize claims and store selection
    this.claim$ = this.claimService.GetClaim();

    // Add back the subscription in componentInit()
    this.subscriptions.add(
      this.store.select(TENANT_STATE).subscribe((tenant: TenantById) => {
        this.tenantDetails = tenant;
      })
    );

  }

  ngOnDestroy() {
    // Unsubscribe from all subscriptions
    this.subscriptions.unsubscribe();
    
    // Unsubscribe from keyfob validation
    if (this.keyfobValidationSubscription) {
      this.keyfobValidationSubscription.unsubscribe();
    }
    
    // Clear BehaviorSubjects
    [
      this.isSubmitting,
      this.error,
      this.showSkeleton$,
      this.showSkeletonForBillDetails$,
      this.billing_interval_type$,
      this.billing_interval_value$,
      this.subscription_category$,
      this.isContract$,
      this.selectedAddons,
      this.billingCycleOption$,
      this.currencySymbol$,
      this.planBreakUpCalculationResponse$,
      this.upgradePlanBreakUpCalculationResponse$,
      this.midCycleAddonBreakUpCalculationResponse$,
      this.showErrorPopup,
      this.inValidCoupon,
      this.alreadyDiscountApplied,
      this.isCouponApplied,
      this.isDiscountApplied,
      this.showOtherPaymentsModel$,
      this.showSessionOwnerChangeModel$,
      this.showChangeBillingNameModel$,
      this.posDeviceList,
      this.paymentGatewayList,
      this.disablePosButton,
      this.tableLoading,
      this.isPresaleTenant
    ].forEach(subject => subject.complete());
  }

  CheckPresaleTenant() {
    this.store.select(TENANTS_INFO).subscribe((tenant: TENANTSINTERFACE) => {
      const tenantDetails = tenant.all_tenant.find(o => o.id == this.tenantId);
      if (tenantDetails != null) {
        this.isPresaleTenant.next(tenantDetails.status.toLowerCase() == 'presales');
        if(this.isPresaleTenant.value){
        this.subscriptionStartdate.setValue(this.timeService.ConvertUTCToLocalDateTime(tenantDetails.tenant_start_date));
        }
      }
    });
  }

  getSettings() {
    const settings = this.advanceSettingService.getAdvanceSettings(this.tenantId);
    if (settings) {
      settings.subscribe({
        next: (res: any) => {
          if (res.items != null) {
            const tax_calculation: any = res.items.find((x: { key: string; }) => x.key.toLowerCase() == "tax_calculation")
            if (tax_calculation != null) {
              if (tax_calculation.value.toLowerCase() == 'inclusive')
                this.isInclusive = true;
            }
            if (Statsig.checkGate("keyfob")) {
              this.keyFobRequired = true;
            } else {
              this.keyFobRequired = false;
            }

            if (this.keyFobRequired) {
              if (this.clientKeyfob != '' && this.clientKeyfob != null) {
                this.keyFobFormControl.setValue(this.clientKeyfob);
              }
              else {
                this.keyFobFormControl.setValue(this.clientKeyfob);
                this.keyFobFormControl.addValidators([Validators.required, Validators.pattern(this.validAlphaNumericPattern)]);
              }
            }
            else {
              this.keyFobFormControl.clearValidators();
              this.keyFobFormControl.setValue(this.clientKeyfob);
            }

            const backdated_billing_setting: any = res.items.find((x: { key: string; }) => x.key.toLowerCase() == "backdated_billing_setting");
            if (backdated_billing_setting != null) {
              if (backdated_billing_setting.value > 0)
                this.minStartDate.setDate(this.minStartDate.getDate() - parseInt(backdated_billing_setting.value));
            }

            const maxSubscriptionStartDate = res.items.find((x: { key: string; }) => x.key.toLowerCase() == "limit_subscription_future_start_in_days");
            if (maxSubscriptionStartDate != null) {
              this.maxSubscriptionStartDate = new Date(new Date().setDate(new Date().getDate() + parseInt(maxSubscriptionStartDate.value)));
            }
          }
        },
      });
    }
  }

  getClientDetails() {
    this.clientService.getClientById(this.clientId).subscribe({
      next: (res: any) => {
        this.clientData = res;
        this.clientKeyfob = this.clientData.current_keyfob;
        this.keyFobFormControl.setValue(this.clientKeyfob);
        if(res.referred_by && res.referred_by > 0) this.getClientReferrals(res.referred_by);
      }, error: () => {
        this.clientKeyfob = '';
        this.keyFobFormControl.setValue(this.clientKeyfob);
      }
    });
  }

  getClientCreditBalance() {
    this.clientService.getClientCreditBalanceByTenantId(this.clientId, this.tenantId).subscribe({
      next: (res: any) => {
        this.creditBalance = res;
      }, error: () => {
        this.creditBalance = 0;
      }
    });
  }

  getClientReferrals(clientId:number) {
    this.clientService.getClientReferrals(this.tenantId, clientId).subscribe({
      next: (res: CLientReferralResponse) => {
        this.clientReferrals = res;
        if(res.items && res.items.length > 0){
          const referrers = res.items.filter(o => o.status == ClientReferralStatus.Active || o.status.toString() == ClientReferralStatus[ClientReferralStatus.Active]);
          if(referrers.length == 1){
            this.referredByClientId = referrers.find(o => o.referrer_id == clientId) ? referrers.find(o => o.referrer_id == clientId)!.referrer_id : 0;
          }
        }
      }
    });
  }

  setSubscriptionStartDate(plan: PlanSummary){
    if(plan.updatedPlanBreakupRequest){
      this.subscriptionStartdate.setValue(this.timeService.ConvertUTCToLocalDateTime(plan.updatedPlanBreakupRequest.subscription_start_date));
    }
  }

  SetFormFields(): void {
    this.fg = this.fb.group({
      ddlMembership: new UntypedFormControl('', []),
      ddlplanSubscriptionList: new UntypedFormControl('', []),
      ddlBillingCycle: new UntypedFormControl('', []),
      billdate: new UntypedFormControl(new Date(), []),
      billingOwner: new UntypedFormControl('', [Validators.required]),
      subscriptionstartdate: new UntypedFormControl(this.subsStartDate, []),
      couponCode: new UntypedFormControl('', []),
      keyfob: new UntypedFormControl(this.clientKeyfob, [Validators.required, Validators.pattern(this.validAlphaNumericPattern)]),
      target_device: new UntypedFormControl(this.CompilationTargets.find(o => o.value == ComplitionTargetDevice[ComplitionTargetDevice.Client]), []),
    });

    this.subsStartDateValue = this.subscriptionStartdate.value;
    this.subsStartDateValue = this.billDate.value;

    this.fg.controls.ddlplanSubscriptionList.valueChanges.subscribe(
      (plan: any) => {
        if (plan && plan.id) {
          this.subscriptionPlanId = plan.id;
          this.isPlanSelected = true;
          this.BindPlanById(plan.tenant_id, plan.id, this.clientId);
          this.GetEligibleCoupons();
        }
      }
    );

    this.recurringMembershipDiscountFormControl.valueChanges.pipe(distinctUntilChanged()).subscribe(
      (value: any) => {
        if (value && value != "") {
          this.RecurringDiscountReason.addValidators([Validators.required]);
        }
        else {
          this.RecurringDiscountReason.clearValidators();
        }
        this.RecurringDiscountReason.updateValueAndValidity();
      }
    );

    // Set up keyfob validation listener with direct API call and debounce
    this.keyfobValidationSubscription = this.keyFobFormControl.valueChanges.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      switchMap((value: string) => {
        if (value && value.trim() && value !== this.clientKeyfob && this.tenantId > 0) {
          this.isValidatingKeyfob = true;
          this.keyfobValidationMessage = '';
          this.cd.detectChanges();
          return this.clientService.validateKeyfob(this.tenantId, value.trim()).pipe(
            catchError((error: any) => {
              // Handle error without breaking the stream
              this.isValidatingKeyfob = false;
              this.isKeyfobValid = false;
              if (error?.originalError?.error?.errorMessage) {
                this.keyfobValidationMessage = error.originalError.error.errorMessage;
              } else {
                this.keyfobValidationMessage = 'Invalid keyfob number';
              }
              this.cd.detectChanges();
              return of(null); // Return null to continue the stream
            })
          );
        } else {
          this.isValidatingKeyfob = false;
          this.isKeyfobValid = false;
          this.keyfobValidationMessage = '';
          this.cd.detectChanges();
          return of(null);
        }
      })
    ).subscribe((response) => {
      if (response !== null) {
        this.isValidatingKeyfob = false;
        this.isKeyfobValid = true;
        this.keyfobValidationMessage = 'Keyfob is valid';
        this.cd.detectChanges();
      }
    });

  }



  BindPlanList(tenant_id: number) {
    this.showSkeleton$.next(true);
    this.showSkeletonForBillDetails$.next(true);
    this.requestParams.set('status', { paramName: 'status', paramValue: Status.Active });
    this.planmasterService.getSubscriptionPlanService(tenant_id, [...this.requestParams.values()]).subscribe({
      next: (planList: GetPlanMasterListResponse<PlanMasterList>) => {
        const oPlan: PlanMasterList[] = planList.items.filter((o) => {
          return (
            (o.status == Status.Active ||
            o.status.toString() == Status[Status.Active]) &&
            o.is_staff_facing_app == true
          );
        });
        this.planSubscription$.next(oPlan);
        if (this.subscriptionPlanId > 0) {
          const selectedPlan = oPlan.find((o) => o.id == this.subscriptionPlanId);
          this.fg.controls.ddlplanSubscriptionList.setValue(selectedPlan);
        }
        else {
          this.showSkeleton$.next(false);
          this.showSkeletonForBillDetails$.next(false);
          this.cd.detectChanges();
        }
      },
      error: () => {
        this.showSkeleton$.next(false);
        this.showSkeletonForBillDetails$.next(false);
        this.cd.detectChanges();
      },
    });
  }

  BindPlanById(tenant_id: number, plan_id: number, client_id: number) {
    this.showSkeletonForBillDetails$.next(true);
    if (plan_id > 0) {
      this.planDetail$ = this.planmasterService.getSubscriptionPlanServiceById(tenant_id, plan_id);
      this.planDetail$.subscribe({
        next: (i: GetPlanMasterByIdResponse) => {
          this.planDetail = i;
          this.selectedPlanDetail$.next(i);
          this.bill_cycle_day = i.bill_cycle_day;
          this.billing_interval_type$.next(i.billing_interval_type?.toString());
          this.billing_interval_value$.next(i.billing_interval_value);
          this.subscription_category$.next(i.subscription_category);

          if (i.subscription_category == PlanType.Contract || i.subscription_category == PlanType.PayAsYouGo || i.feature_is_cash_recurring) {
            this.onlinePayment = true;
          }
          if (
            i.subscription_category == PlanCategory.DropIn.toString() ||
            i.subscription_category == PlanCategory[PlanCategory.DropIn] ||
            i.subscription_category == PlanCategory.PaidInFull.toString() ||
            i.subscription_category == PlanCategory[PlanCategory.PaidInFull] ||
            i.feature_is_cash_recurring
          ) {
            this.isCashRecurring = true;
          }

          //set is Contract.
          this.SetContractRecurring(
            i.contract_term,
            i.feature_is_cash_recurring
          );

          this.SetBillingCycle_init();
          this.showSessionOwnerButon(i);
          if (this.billingSignupMode == SignUpMode.Upgrade || this.billingSignupMode.toString() == SignUpMode[SignUpMode.Upgrade]) {
            this.handlePlanBreakUpResponse(this.planSummary.planBreakupResponse!);
          }
          else {
            this.bindPlanBreakUp(tenant_id, plan_id, client_id);
          }
        },
        error: (error: AppErrors) => {
          this.errorMessages = [];
          if (error instanceof NotFoundError) {
            this.errMsg = error.originalError.message;
          } else {
            if (error.originalError.status == 500) {
              this.errorMessages.push(error.originalError.error.errorMessage);
              this.errorDataModal = this.errorMessages;
              this.showErrorPopup?.next(true);
              this.errorMessages = [];
            } else {
              error.originalError.error.forEach((e: any) => {
                this.errorMessages.push(e.errorMessage);
              });
              this.errorDataModal = this.errorMessages;
              this.showErrorPopup?.next(true);
            }
          }
        }
      });
    }
    else {
      this.showSkeleton$.next(false);
      this.showSkeletonForBillDetails$.next(false);
      this.cd.detectChanges();
    }
  }

  bindPlanBreakUp(tenant_id: number, plan_id: number, client_id: number): void {
    this.showSkeletonForBillDetails$.next(true);
    this.tableLoading.next(true);
    if (this.billingSignupMode == SignUpMode.SignUp || this.billingSignupMode.toString() == SignUpMode[SignUpMode.SignUp]) {
      let planBreakUpCalculationRequest: PlanBreakUpCalculationRequest ={} as PlanBreakUpCalculationRequest;
      if(this.planSummary && this.planSummary.updatedPlanBreakupRequest && !this.isStartDateChanged)
      {
        planBreakUpCalculationRequest.subscription_start_date = this.planSummary.updatedPlanBreakupRequest.subscription_start_date;
        planBreakUpCalculationRequest.addon_service_id = this.selectedAddons.value.map(o => o.id);
        planBreakUpCalculationRequest.client_id = this.clientId;
        planBreakUpCalculationRequest.coupon_code = this.couponCodeFormControl.value;
        planBreakUpCalculationRequest.is_coupon_code_applied = this.couponApplied;
        planBreakUpCalculationRequest.subscription_bill_cycle_day = this.getBillingCycleDay();
        planBreakUpCalculationRequest.issue_date = this.timeService.ConvertLocalDateTimeToUTC(this.billDate.value);
        planBreakUpCalculationRequest.sponsor_contract_id = this.planSummary.updatedPlanBreakupRequest.sponsor_contract_id;
        planBreakUpCalculationRequest.is_family_owner = this.planSummary.updatedPlanBreakupRequest.is_family_owner;
      }
      else
      {
        const startDate = new Date(new Date(this.subscriptionStartdate.value).setHours(0, 0, 0));
        planBreakUpCalculationRequest = {
        client_id: this.clientId,
        coupon_code: this.couponCodeFormControl.value,
        is_coupon_code_applied: this.couponApplied,
        issue_date: this.timeService.ConvertLocalDateTimeToUTC(this.billDate.value),
        subscription_bill_cycle_day: this.getBillingCycleDay(),
        subscription_start_date: this.timeService.ConvertLocalDateTimeToUTC(startDate),
        addon_service_id: this.selectedAddons.value.map(o => o.id),
        sponsor_contract_id: this.planSummary.sponsor_contract_id,
        is_family_owner: this.planSummary.is_family_owner
      };
      }  
      

      if(this.planSummary.subscriptionProductsAndCharges && (this.planSummary.subscriptionProductsAndCharges.products || this.planSummary.subscriptionProductsAndCharges.charges))
      {
        const product:any[] = [];
        this.planSummary.subscriptionProductsAndCharges.products.forEach(o => {
          product.push({
            sku_id: o.sku_id,
            quantity: o.quantity,
            is_plan_sku: o.is_plan_sku || false
          })
        });
        planBreakUpCalculationRequest.products = product;
        planBreakUpCalculationRequest.charges = this.planSummary.subscriptionProductsAndCharges.charges;
      }
      this.plansubscriptionService.getPlanBreakUpCalculation(tenant_id, plan_id, planBreakUpCalculationRequest).subscribe({
        next: (_objResponse: PlanBreakUpCalculationResponse) => {
          this.handlePlanBreakUpResponse(_objResponse);
        },
        error: (error: AppErrors) => {
          this.showSkeleton$.next(false);
          this.showSkeletonForBillDetails$.next(false);
          this.cd.detectChanges();
          this.errorMessages = [];
          this.errorDataModal = [];
          this.handleError(error);
        },
      });
    }
    else if (this.billingSignupMode == SignUpMode.MidCycleAddons || this.billingSignupMode.toString() == SignUpMode[SignUpMode.MidCycleAddons]) {

      const request: MidCycleAddonBreakupRequest = {
        coupon_code: this.couponCodeFormControl.value,
        is_coupon_code_applied: this.couponApplied,
        issue_date: this.timeService.ConvertLocalDateTimeToUTC(this.billDate.value),
        non_recurring_addons: [],
        recurring_addons: []
      };
      this.selectedAddons.value.forEach(o => {
        if (o.is_recurring) {
          request.recurring_addons.push({
            addons_service_id: o.id,
            recurring_addons_start_mode: o.start_mode!.toString(),
            discount_amount_in_minor_currency: 0
          })
        }
        else {
          request.non_recurring_addons.push({
            addons_service_id: o.id,
            addons_start_date: this.timeService.ConvertLocalDateTimeToUTC(o.start_date!),
            discount_amount_in_minor_currency: 0
          })
        }
      });

      this.plansubscriptionService.getAddonBreakUpCalculation(tenant_id, client_id, this.fromSubscription.id, request).subscribe({
        next: (response: AddonBreakUpResponse) => {
          this.midCycleAddonBreakUpCalculationResponse$.next(response);
          const _objResponse: PlanBreakUpCalculationResponse = {} as PlanBreakUpCalculationResponse;
          _objResponse.plan_breakup_calculation = {} as PlanBreakUpCalculation;
          _objResponse.plan_breakup_calculation.charging_today = {} as ChargingToday;
          _objResponse.plan_breakup_calculation.charging_recurring = {} as RecurringBreakUp;
          _objResponse.plan_breakup_calculation.charging_today.service_non_recurring = {} as NonRecurringBreakUp;
          _objResponse.plan_breakup_calculation.charging_today.service_non_recurring.services = [] as ServiceBreakUp[];
          _objResponse.plan_breakup_calculation.charging_today.service_first_charge = response.charging_today_addons && response.charging_today_addons.service_first_charge_mid_addons ? response.charging_today_addons.service_first_charge_mid_addons[0] : {} as ServiceFirstCharge;
          _objResponse.plan_breakup_calculation.charging_today.service_non_recurring.services = response.charging_today_addons.non_recurring_addons;
          _objResponse.plan_breakup_calculation.charging_today.signup_charges = [] as ChargeBreakUp[];
          _objResponse.plan_breakup_calculation.charging_recurring.services = response.recurring_addons;
          this.handlePlanBreakUpResponse(_objResponse);
          this.cd.detectChanges();
        },
        error: (error: AppErrors) => {
          this.tableLoading.next(false);
          this.showSkeleton$.next(false);
          this.showSkeletonForBillDetails$.next(false);
          this.cd.detectChanges();
          this.errorMessages = [];
          this.errorDataModal = [];
          this.handleError(error);
        },
      });

    }
    else {
      const upgradeRequest: UpgradePlanBreakUpRequest = {
        is_coupon_code_applied: this.couponApplied,
        issue_date: this.timeService.ConvertLocalDateTimeToUTC(this.billDate.value),
        upgrade_to_plan_id: this.subscriptionPlanId,
        coupon_code: this.couponCodeFormControl.value,
      };
      this.upgradeService.UpgradeCalculation(tenant_id, client_id, this.fromSubscription.id, upgradeRequest).subscribe({
        next: (_objResponse: PlanBreakUpCalculationResponse) => {
          this.handlePlanBreakUpResponse(_objResponse);
        },
        error: (error: AppErrors) => {
          this.showSkeleton$.next(false);
          this.showSkeletonForBillDetails$.next(false);
          this.cd.detectChanges();
          this.errorMessages = [];
          this.errorDataModal = [];
          this.handleError(error);
        },
      });
    }
  }

  handlePlanBreakUpResponse(_objResponse: PlanBreakUpCalculationResponse) {
    this.errorMessages = [];
    this.errorDataModal = [];
    this.error.next(null);
    this.isOverlapping = false;
    this.inValidCoupon.next(false);
    this.tableLoading.next(false);
    if (_objResponse.plan_breakup_calculation != null) {
    const products:any[] = [];
    this.planSummary.subscriptionProductsAndCharges?.products.forEach(o => {   
       products.push({
        sku_id: o.sku_id,
        quantity: o.quantity,
        base_cost_in_minor_currency: o.product_sku?.unit_price_minor || 0,
        discount_amt_in_minor_currency: 0,
        taxable_cost_in_minor_currency: o.product_sku?.unit_price_minor || 0,
        taxgrp_id: 0,
        tax: [],  
        discount_reason: '',
        is_plan_sku: false,
        is_fulfilled: true
        });
      });
      _objResponse.plan_breakup_calculation.charging_today.products = products;
      this.upgradePlanBreakUpCalculationResponse$.next(_objResponse);
      this.planBreakUpCalculationResponse$.next(_objResponse);
      this.planBreakUpCalculation$.next(_objResponse.plan_breakup_calculation);
      this.overLappingSubscriptionSignUp$.next(_objResponse.overlapping_subscription);
      this.initializeDynamicControl(_objResponse.plan_breakup_calculation);
    } else {
      if (_objResponse.overlapping_subscription && _objResponse.overlapping_subscription.overlapping_subscription_signup != null) {
        this.errorMessages.push(
          _objResponse.overlapping_subscription
            .overlapping_subscription_signup.overlapping_errormessage
        );
        this.errorDataModal = this.errorMessages;
        this.showErrorPopup?.next(true);
        this.isOverlapping = true;
      } else {
        if (_objResponse.overlapping_subscription && _objResponse.overlapping_subscription.overlapping_client_subscription && _objResponse.overlapping_subscription.overlapping_client_subscription.new_date != null) {
          const endDate = _objResponse.overlapping_subscription.overlapping_client_subscription.new_date;
          const startDate = new Date(new Date(endDate.subs_start_date).setDate(new Date(endDate.subs_start_date).getDate() + 1));
          const formatedDate = this.timeService.formatDate(startDate, 'mediumDate');
          this.confirmDialogForSignupDateOverlap(startDate, formatedDate);
          this.isOverlapping = true;
        } else {
          this.errorMessages.push(_objResponse.overlapping_subscription.overlapping_client_subscription.overlapping_errormessage);
          this.errorDataModal = this.errorMessages;
          this.showErrorPopup?.next(true);
        }
      }
    }
    this.showSkeleton$.next(false);
    this.showSkeletonForBillDetails$.next(false);
    this.cd.detectChanges();
  }

  initializeDynamicControl(_objResponse: PlanBreakUpCalculation) {
    this.frmFirstTimeBaseCostAmount = this.getTotalBaseCost(
      _objResponse.charging_today.service_first_charge.services
    );
    this.netCost$.subscribe((obj: number) => {
      this.firstTimeAmount =
        this.commonService.ConvertAmountFromMinorCurrency(obj);
    });
    this.firstTimeTaxAmount = this.getTotalTaxAmount(
      _objResponse.charging_today.service_first_charge.services
    );

    this.frmNonRecurringBaseCostAmount = this.getTotalBaseCost(
      _objResponse.charging_today.service_non_recurring.services
    );

    this.nonRecurringNetCost$.subscribe((obj: number) => {
      this.nonRecurringAmount =
        this.commonService.ConvertAmountFromMinorCurrency(obj);
    });
    this.nonRecurringTaxAmount = this.getTotalTaxAmount(
      _objResponse.charging_today.service_non_recurring.services
    );

    this.recurringMembershipBaseCost = this.getTotalBaseCost(
      _objResponse.charging_recurring.services
    );

    this.baseCostRecurring$.subscribe((obj: number) => {
      this.recurringMembershipAmount =
        this.commonService.ConvertAmountFromMinorCurrency(obj);
    });

    this.recurringMembershipTaxAmount = this.getTotalTaxAmount(
      _objResponse.charging_recurring.services
    );

    this.firstTimeDiscountFormControl.addValidators([
      Validators.required,
      Validators.min(0)
  ]);
    this.nonRecurringDiscountFormControl.addValidators([
      Validators.required,
      Validators.min(0)
  ]);

    const fg: UntypedFormGroup = new UntypedFormGroup({});
    _objResponse.charging_today.signup_charges.forEach(
      (value: ChargeBreakUp) => {
        fg.addControl(
          'chargesbasecost_' + value.id.toString(),
          new UntypedFormControl(value.amount_in_minor_currency, [
            Validators.required
  ])
        );
        fg.addControl(
          'charges_' + value.id.toString(),
          new UntypedFormControl(
            this.commonService.ConvertAmountFromMinorCurrency(
              this.getChargeNetCost(value)
            ),
            [Validators.required]
          )
        );
        fg.addControl(
          'discount_' + value.id.toString(),
          new UntypedFormControl(
            value.discount_amt_in_minor_currency,
            Validators.required
          )
        );
      }
    );
    if (this.charges.controls.length > 0) {
      this.charges.clear();
    }
    this.charges.push(fg);
    this.charges.updateValueAndValidity();

    if (_objResponse.charging_today.deposit && _objResponse.charging_today.deposit.length > 0) {
      const depositFormGroup: UntypedFormGroup = new UntypedFormGroup({});
      _objResponse.charging_today.deposit.forEach(
        (value: Deposit) => {
          depositFormGroup.addControl(
            'despositbasecost_' + value.deposit_internal_id.toString(),
            new UntypedFormControl(value.services.reduce(
              (acc, obj) => {
                return (
                  acc + obj.base_cost_in_minor_currency
                );
              },
              0
            ), [Validators.required]));
          depositFormGroup.addControl(
            'deposit_' + value.deposit_internal_id.toString(),
            new UntypedFormControl(
              this.commonService.ConvertAmountFromMinorCurrency(
                this.getDepositServiceAmount(value)
              ),
              [Validators.required]
            )
          );
          depositFormGroup.addControl(
            'despositdiscount_' + value.deposit_internal_id.toString(),
            new UntypedFormControl(
              value.services.reduce(
                (acc, obj) => {
                  return (
                    acc + obj.discount_amt_in_minor_currency
                  );
                },
                0
              ),
              Validators.required
            )
          );
        }
      );

      if (this.deposits.controls.length > 0) {
        this.deposits.clear();
      }
      this.deposits.push(depositFormGroup);
      this.deposits.updateValueAndValidity();
    }

    // Handle products form controls
    if (_objResponse.charging_today.products && _objResponse.charging_today.products.length > 0) {
      const productsFormGroup: UntypedFormGroup = new UntypedFormGroup({});
      _objResponse.charging_today.products.forEach(
        (value: any) => {
          productsFormGroup.addControl(
            'productbasecost_' + value.sku_id.toString(),
            new UntypedFormControl(value.base_cost_in_minor_currency, [
              Validators.required
            ])
          );
          productsFormGroup.addControl(
            'product_' + value.sku_id.toString(),
            new UntypedFormControl(
              this.commonService.ConvertAmountFromMinorCurrency(
                this.getProductNetCost(value)
              ),
              [Validators.required]
            )
          );
          productsFormGroup.addControl(
            'productdiscount_' + value.sku_id.toString(),
            new UntypedFormControl(
              value.discount_amt_in_minor_currency,
              Validators.required
            )
          );
        }
      );

      if (this.products.controls.length > 0) {
        this.products.clear();
      }
      this.products.push(productsFormGroup);
      this.products.updateValueAndValidity();
    }

  }

  getFromSubscription(plan_id: number, client_id: number) {
    if (plan_id > 0) {
      this.clientService.getSingleSubscriptionById(client_id, plan_id).subscribe({
        next: (response: SubscriptionById) => {
          this.fromSubscription = response;
          this.billDate.disable();
        },
        error: (error: AppErrors) => {
          this.errorMessages = [];
          if (error instanceof NotFoundError) {
            this.errMsg = error.originalError.message;
          } else {
            if (error.originalError.status == 500) {
              this.errorMessages.push(error.originalError.error.errorMessage);
              this.errorDataModal = this.errorMessages;
              this.showErrorPopup?.next(true);
              this.errorMessages = [];
            } else {
              error.originalError.error.forEach((e: any) => {
                this.errorMessages.push(e.errorMessage);
              });
              this.errorDataModal = this.errorMessages;
              this.showErrorPopup?.next(true);
            }
          }
        }
      });
    }
    else {
      this.showSkeleton$.next(false);
      this.showSkeletonForBillDetails$.next(false);
      this.cd.detectChanges();
    }
  }

  GetEligibleCoupons() {
    this.couponService.getEligibleCoupons(this.tenantId, this.subscriptionPlanId).subscribe({
      next: (coupons: EligibleCoupons) => {
        this.couponCollection = [];
        coupons.items.forEach((coupon: OfferMaster) => {
          if (coupon.coupon_codes && coupon.coupon_codes.length > 0 && (coupon.status == Status.Active || coupon.status.toString() == Status[Status.Active])) {
            this.couponCollection.push({
              name: coupon.name_primary_language,
              value: coupon.coupon_codes[0].coupon_code,
            });
          }
        });
      },
      error: () => {
        this.couponCollection = [];
      },
    });
  }

  SetContractRecurring(
    contract_term: number,
    feature_is_cash_recurring: boolean
  ) {
    if (contract_term != 1) this.isContract$.next(true);
    if (feature_is_cash_recurring) this.isCashRecurring = true;
  }

  getPlanType(c: PlanCategory): string {
    let strCategory = '';
    switch (c.toString()) {
      case PlanCategory.Contract.toString():
      case PlanCategory[PlanCategory.Contract]:
        strCategory = PlanType.Contract.toUpperCase();
        break;
      case PlanCategory.DropIn.toString():
      case PlanCategory[PlanCategory.DropIn]:
        strCategory = PlanType.DropIn.toUpperCase();
        break;
      case PlanCategory.PaidInFull.toString():
      case PlanCategory[PlanCategory.PaidInFull]:
        strCategory = PlanType.PaidInFull.toUpperCase();
        break;
      case PlanCategory.PayAsYouGo.toString():
      case PlanCategory[PlanCategory.PayAsYouGo]:
        strCategory = PlanType.PayAsYouGo.toUpperCase();
        break;
    }
    return strCategory;
  }

  getPlanAmount(p: PlanMasterList): number {
    let amt = 0;
    switch (p.subscription_category.toString()) {
      case PlanCategory.Contract.toString():
      case PlanCategory[PlanCategory.Contract]:
        amt = p.recurring_services_in_minor_currency;
        break;
      case PlanCategory.DropIn.toString():
      case PlanCategory[PlanCategory.DropIn]:
        amt = p.non_recurring_services_in_minor_currency;
        break;
      case PlanCategory.PaidInFull.toString():
      case PlanCategory[PlanCategory.PaidInFull]:
        amt = p.non_recurring_services_in_minor_currency;
        break;
      case PlanCategory.PayAsYouGo.toString():
      case PlanCategory[PlanCategory.PayAsYouGo]:
        amt = p.recurring_services_in_minor_currency;
        break;
    }
    return amt;
  }

  SetBillingCycle_init() {
    const startDate = new Date(new Date(this.subscriptionStartdate.value).setHours(0, 0, 0));
    const newSubscriptiondate = this.timeService.ConvertLocalDateTimeToUTCInDateObject(startDate);
    let day: number = 0;
    const weekDays: number = newSubscriptiondate.getDay();
    const days: any[] = [];

    if (this.billing_interval_type$.value.toString() == PlanIntervalType[PlanIntervalType.Month]
    ) {
      const d: string[] = this.bill_cycle_day.split(',');
      day = newSubscriptiondate.getDate();

      d.forEach((obj: string) => {
        if (parseInt(obj) == 0) {
          //if (d.indexOf(day.toString()) < 0) {
          this.translate.get('POS.MEMBERSHIP_ADDON')
            .subscribe((translation) => {
              days.push({
                value: day,
                name: translation.SIGNUPDATE,
                isSignup: true,
              });
            });
          //}
        } else
          days.push({
            value: parseInt(obj),
            name: this.nth(parseInt(obj)) + ' of month',
            isSignup: false,
          });
      });

      let nearestDay: number = 0;
      const subDate = newSubscriptiondate;

      for (let i = 0; i < 32; i++) {
        days.forEach((obj: any) => {
          if (subDate.getDate() == parseInt(obj['value'])) {
            nearestDay = days.find((v: any) => v.value == obj['value']) || null;
          }
        });
        if (nearestDay) break;
        subDate.setDate(subDate.getDate() + 1);
      }

      if (nearestDay) this.billingCycle.setValue(nearestDay);
      else this.billingCycle.setValue(days[0]);
    }

    if (
      this.billing_interval_type$.value.toString() ==
      PlanIntervalType[PlanIntervalType.Week]
    ) {
      const d: string[] = this.bill_cycle_day.split(',');
      day = newSubscriptiondate.getDay();

      d.forEach((obj: string) => {
        if (parseInt(obj) == 0) {
          //if (d.indexOf(((weekDays + 1) * -1).toString()) < 0)
          //days.push({ value: (weekDays + 1) * -1, name: this.weekDays[weekDays], isSignup: true });

          this.translate
            .get('POS.MEMBERSHIP_ADDON')
            .subscribe((translation) => {
              days.push({
                value: (weekDays + 1) * -1,
                name: translation.SIGNUPDATE,
                isSignup: true,
              });
            });
        } else
          days.push({
            value: parseInt(obj),
            name: this.weekDays[parseInt(obj) * -1 - 1],
            isSignup: false,
          });
      });

      let nearestDay: number = 0;
      //let nearestDay = days.find((v: any) => v.value <= days) || null;

      const subDate = newSubscriptiondate;

      for (let i = 0; i < 8; i++) {
        days.forEach((obj: any) => {
          if ((subDate.getDay() + 1) * -1 == parseInt(obj['value'])) {
            nearestDay = days.find((v: any) => v.value == obj['value']) || null;
          }
        });
        if (nearestDay) break;
        subDate.setDate(subDate.getDate() + 1);
      }

      if (nearestDay) this.billingCycle.setValue(nearestDay);
      else this.billingCycle.setValue(days[0]);
    }
    this.billingCycleOption$.next(days);
  }

  SetBillingCycle() {
    const startDate = new Date(new Date(this.subscriptionStartdate.value).setHours(0, 0, 0));
    const newSubscriptiondate = this.timeService.ConvertLocalDateTimeToUTCInDateObject(startDate);
    let day: number = 0;
    const weekDays: number = newSubscriptiondate.getDay();

    if (
      this.billing_interval_type$.value.toString() == PlanIntervalType[PlanIntervalType.Month]
    ) {
      day = newSubscriptiondate.getDate();

      if (this.billingCycleOption$.value.find((v: any) => v.isSignup == true)) {
        this.billingCycleOption$.value.find(
          (v: any) => v.isSignup == true
        ).value = day.toString();
      }
    }
    if (
      this.billing_interval_type$.value.toString() == PlanIntervalType[PlanIntervalType.Week]
    ) {
      day = newSubscriptiondate.getDay();

      if (this.billingCycleOption$.value.find((v: any) => v.isSignup == true)) {
        this.billingCycleOption$.value.find(
          (v: any) => v.isSignup == true
        ).value = (weekDays + 1) * -1;
      }
    }
  }

  //#region

  allServiceNameHtml(oData: GetPlanMasterByIdResponse): string {
    const serviceCategoryName: string[] = [];
    const serviceCategory: any[] = [];
    oData.recurring_services.forEach((oService: PlanMasterServices) => {
      if (serviceCategoryName.indexOf(oService.name_primary_language) == -1) {
        serviceCategoryName.push(oService.name_primary_language);
        serviceCategory.push({
          name: oService.name_primary_language,
          isBaseMembership: oService.is_base_membership,
        });
      }
    });
    return this.GetServiceNames(serviceCategory);
  }

  allServiceNameForAddons(): string {
    const serviceCategoryName: string[] = [];
    const serviceCategory: any[] = [];
    this.fromSubscription.recurring_template_recurring_services.forEach((oService: RecurringTemplateRecurringService) => {
      if (serviceCategoryName.indexOf(oService.service_category_name_primary_language) == -1) {
        serviceCategoryName.push(oService.service_category_name_primary_language);
        serviceCategory.push({
          name: oService.service_category_name_primary_language,
          isBaseMembership: oService.service_is_base_membership,
        });
      }
    });

    return this.GetServiceNames(serviceCategory);
  }

  GetServiceNames(serviceCategory: any[]) {
    const str: string = `{{First}} {{Others}}`;

    let other: string = '';
    let first: string = '';
    for (let i = 0; i < serviceCategory.length; i++) {
      if (i == 0)
        first =
          serviceCategory[i].name +
          (serviceCategory[i].isBaseMembership
            ? ' <span class="inline-block px-2 line-height-4 text-xxs surface-200 border-round" > Base Membership </span>'
            : '');
      else
        other =
          other +
          '<br class="md:hidden"> + ' +
          serviceCategory[i].name +
          (serviceCategory[i].isBaseMembership
            ? ' <span class="inline-block px-2 line-height-4 text-xxs surface-200 border-round" > Base Membership </span>'
            : '');
    }
    return str.replace('{{First}}', first).replace('{{Others}}', other);
  }

  handleError(error: any) {
    if (error.originalError.error.length == undefined) {
      this.error.next(null);
      this.errorMessages.push('Something went wrong');
      this.showErrorPopup?.next(true);
    }
    else {
      if (error.originalError.error.length > 0) {
        error.originalError.error.forEach((e: any) => {
          if (e.identifier == 'OfferMasterCouponCodeLink' || e.identifier == 'CouponCodeValidation') {
            this.inValidCoupon.next(true);
            this.error.next(error);
            this.showErrorPopup?.next(true);
            this.errorOnCouponApply = true;
            this.RemoveCouponCode(false);
          }
          else if (e.errorCode.toLowerCase() == 'expired' || e.identifier.toLowerCase() == 'offermaster') {
            this.inValidCoupon.next(true);
            this.error.next(error);
            this.showErrorPopup?.next(true);
            this.errorOnCouponApply = true;
            this.RemoveCouponCode(false);
          } else {
            this.error.next(error);
            this.showErrorPopup?.next(true);
          }
        });
      } else {
        this.error.next(error);
        this.showErrorPopup?.next(true);
      }
    }
  }

  getChargesNetCost(taxableAmount: number, taxAmount: number): number {
    return this.isInclusive ? taxableAmount + taxAmount : taxableAmount;
  }

  getNetCost(taxableAmount: number, taxAmount: number): number {
    return this.isInclusive ? taxableAmount + taxAmount : taxableAmount;
  }

  nth(i: number) {
    const j = i % 10;
    const k = i % 100;
    if (j == 1 && k != 11) {
      return i + 'st';
    }
    if (j == 2 && k != 12) {
      return i + 'nd';
    }
    if (j == 3 && k != 13) {
      return i + 'rd';
    }
    return i + 'th';
  }


  calculateDiscount(
    basePriceCtrl: UntypedFormControl,
    amtCtrl: UntypedFormControl,
    disCtrl: UntypedFormControl
  ) {
    let lineItemChargeAmount = 0;
    lineItemChargeAmount = this.commonService.ConvertAmountFromMinorCurrency(
      basePriceCtrl.value
    );
    if (
      lineItemChargeAmount -
      (lineItemChargeAmount * this.single_staff_discount) / 100 <=
      amtCtrl.value &&
      lineItemChargeAmount >= amtCtrl.value
    ) {
      disCtrl.setValue(100 - (amtCtrl.value * 100) / lineItemChargeAmount); // set discount
      this.inValidDiscount = false;
      this.cd.detectChanges();
    } else {
      setTimeout(() => {
        this.userDiscountLimit = this.single_staff_discount;
        amtCtrl.setValue(lineItemChargeAmount);
        disCtrl.setValue(0);
        this.inValidDiscount = true;
        this.cd.detectChanges();
      }, 10);
    }
  }

  async calculateAmount(
    basePriceCtrl: UntypedFormControl,
    amtCtrl: UntypedFormControl,
    disCtrl: UntypedFormControl
  ) {
    let lineItemChargeAmount: number = basePriceCtrl.value;
    lineItemChargeAmount =
      this.commonService.ConvertAmountFromMinorCurrency(lineItemChargeAmount);
    const netValue =
      lineItemChargeAmount - (lineItemChargeAmount * disCtrl.value) / 100;
    if (
      lineItemChargeAmount -
      (lineItemChargeAmount * this.single_staff_discount) / 100 <=
      netValue
    ) {
      amtCtrl.setValue(netValue);
      this.inValidDiscount = false;
      this.cd.detectChanges();

    } else {
      setTimeout(() => {
        this.userDiscountLimit = this.single_staff_discount;
        amtCtrl.setValue(lineItemChargeAmount);
        disCtrl.setValue(0);
        this.inValidDiscount = true;
        this.cd.detectChanges();
      }, 10);
    }
  }

  calculateChargeDiscount(lineItemChargeAmount: number, amtCtrl: string, disCtrl: string) {
    lineItemChargeAmount = this.commonService.ConvertAmountFromMinorCurrency(lineItemChargeAmount);
    const amtControl: any = ((this.fgProducts.controls.charges as UntypedFormArray).controls[0] as UntypedFormGroup).controls[amtCtrl];
    const disControl: any = ((this.fgProducts.controls.charges as UntypedFormArray).controls[0] as UntypedFormGroup).controls[disCtrl];

    if (lineItemChargeAmount - (lineItemChargeAmount * this.single_staff_discount) / 100 <= amtControl.value && lineItemChargeAmount >= amtControl.value) {
      disControl.setValue(100 - (amtControl.value * 100) / lineItemChargeAmount);
      this.inValidDiscount = false;
      this.cd.detectChanges();
    } else {
      setTimeout(() => {
        this.userDiscountLimit = this.single_staff_discount;
        amtControl.setValue(lineItemChargeAmount);
        disControl.setValue(0);
        this.inValidDiscount = true;
        this.cd.detectChanges();
      }, 10);
    }
  }

  calculateChargeAmount(lineItemChargeAmount: number, amtCtrl: string, disCtrl: string) {
    const amtControl: any = ((this.fgProducts.controls.charges as UntypedFormArray).controls[0] as UntypedFormGroup).controls[amtCtrl];
    const disControl: any = ((this.fgProducts.controls.charges as UntypedFormArray).controls[0] as UntypedFormGroup).controls[disCtrl];

    lineItemChargeAmount = this.commonService.ConvertAmountFromMinorCurrency(lineItemChargeAmount);
    const netValue = lineItemChargeAmount - (lineItemChargeAmount * disControl.value) / 100;

    if (lineItemChargeAmount - (lineItemChargeAmount * this.single_staff_discount) / 100 <= netValue) {
      amtControl.setValue(netValue);
      this.inValidDiscount = false;
      this.cd.detectChanges();
    } else {
      setTimeout(() => {
        this.userDiscountLimit = this.single_staff_discount;
        amtControl.setValue(lineItemChargeAmount);
        disControl.setValue(0);
        this.inValidDiscount = true;
        this.cd.detectChanges();
      }, 10);
    }
  }

  calculateProductDiscount(lineItemProductAmount: number, amtCtrl: string, disCtrl: string) {
    lineItemProductAmount = this.commonService.ConvertAmountFromMinorCurrency(lineItemProductAmount);
    const amtControl: any = ((this.fgProducts.controls.products as UntypedFormArray).controls[0] as UntypedFormGroup).controls[amtCtrl];
    const disControl: any = ((this.fgProducts.controls.products as UntypedFormArray).controls[0] as UntypedFormGroup).controls[disCtrl];

    if (lineItemProductAmount - (lineItemProductAmount * this.single_staff_discount) / 100 <= amtControl.value && lineItemProductAmount >= amtControl.value) {
      disControl.setValue(100 - (amtControl.value * 100) / lineItemProductAmount);
      this.inValidDiscount = false;
      this.cd.detectChanges();
    } else {
      setTimeout(() => {
        this.userDiscountLimit = this.single_staff_discount;
        amtControl.setValue(lineItemProductAmount);
        disControl.setValue(0);
        this.inValidDiscount = true;
        this.cd.detectChanges();
      }, 10);
    }
  }

  calculateProductAmount(lineItemProductAmount: number, amtCtrl: string, disCtrl: string) {
    const amtControl: any = ((this.fgProducts.controls.products as UntypedFormArray).controls[0] as UntypedFormGroup).controls[amtCtrl];
    const disControl: any = ((this.fgProducts.controls.products as UntypedFormArray).controls[0] as UntypedFormGroup).controls[disCtrl];

    lineItemProductAmount = this.commonService.ConvertAmountFromMinorCurrency(lineItemProductAmount);
    const netValue = lineItemProductAmount - (lineItemProductAmount * disControl.value) / 100;

    if (lineItemProductAmount - (lineItemProductAmount * this.single_staff_discount) / 100 <= netValue) {
      amtControl.setValue(netValue);
      this.inValidDiscount = false;
      this.cd.detectChanges();
    } else {
      setTimeout(() => {
        this.userDiscountLimit = this.single_staff_discount;
        amtControl.setValue(lineItemProductAmount);
        disControl.setValue(0);
        this.inValidDiscount = true;
        this.cd.detectChanges();
      }, 10);
    }
  }

  calculateRecurringAmount(basePriceCtrl: UntypedFormControl, amtCtrl: UntypedFormControl, disCtrl: UntypedFormControl) {
    let lineItemChargeAmount: number = basePriceCtrl.value;
    lineItemChargeAmount = this.commonService.ConvertAmountFromMinorCurrency(lineItemChargeAmount);
    const netValue = lineItemChargeAmount - (lineItemChargeAmount * disCtrl.value) / 100;
    if (lineItemChargeAmount - (lineItemChargeAmount * this.recurring_staff_discount) / 100 <= netValue) {
      amtCtrl.setValue(netValue);
      this.inValidRecurringDiscount = false;
    } else {
      setTimeout(() => {
        this.userDiscountLimit = this.recurring_staff_discount;
        amtCtrl.setValue(lineItemChargeAmount);
        disCtrl.setValue(0);
        this.inValidRecurringDiscount = true;
        this.cd.detectChanges();
      }, 10);
    }
    this.cd.detectChanges();

  }

  calculateRecurringDiscount(
    basePriceCtrl: UntypedFormControl,
    amtCtrl: UntypedFormControl,
    disCtrl: UntypedFormControl
  ) {
    let lineItemChargeAmount: number = 0;
    lineItemChargeAmount = this.commonService.ConvertAmountFromMinorCurrency(basePriceCtrl.value);
    if (
      lineItemChargeAmount -
      (lineItemChargeAmount * this.recurring_staff_discount) / 100 <=
      amtCtrl.value &&
      lineItemChargeAmount >= amtCtrl.value
    ) {
      disCtrl.setValue(100 - (amtCtrl.value * 100) / lineItemChargeAmount); // set discount
      this.inValidRecurringDiscount = false;
    } else {
      setTimeout(() => {
        this.userDiscountLimit = this.recurring_staff_discount;
        // await this.timeout(1000);
        amtCtrl.setValue(lineItemChargeAmount);
        disCtrl.setValue(0);
        this.inValidRecurringDiscount = true;
        this.cd.detectChanges();
      }, 10);
    }
    this.cd.detectChanges();
  }


  calculateDepositDiscount(lineItemChargeAmount: number, amtCtrl: string, disCtrl: string) {
    lineItemChargeAmount = this.commonService.ConvertAmountFromMinorCurrency(lineItemChargeAmount);
    const amtControl: any = ((this.fgProducts.controls.deposits as UntypedFormArray).controls[0] as UntypedFormGroup).controls[amtCtrl];
    const disControl: any = ((this.fgProducts.controls.deposits as UntypedFormArray).controls[0] as UntypedFormGroup).controls[disCtrl];

    if (lineItemChargeAmount - (lineItemChargeAmount * Number(this.single_staff_discount)) / 100 >= amtControl.value && lineItemChargeAmount >= amtControl.value) {
      disControl.setValue(100 - (amtControl.value * 100) / lineItemChargeAmount);
      this.inValidDiscount = false;
    } else {
      setTimeout(() => {
        this.userDiscountLimit = this.single_staff_discount;
        amtControl.setValue(lineItemChargeAmount);
        disControl.setValue(0);
        this.inValidDiscount = true;
        this.cd.detectChanges();
      }, 10);
    }
    this.cd.detectChanges();
  }

  calculateDepositAmount(lineItemChargeAmount: number, amtCtrl: string, disCtrl: string) {
    const amtControl: any = ((this.fgProducts.controls.deposits as UntypedFormArray).controls[0] as UntypedFormGroup).controls[amtCtrl];
    const disControl: any = ((this.fgProducts.controls.deposits as UntypedFormArray).controls[0] as UntypedFormGroup).controls[disCtrl];

    lineItemChargeAmount = this.commonService.ConvertAmountFromMinorCurrency(lineItemChargeAmount);
    const netValue = lineItemChargeAmount - (lineItemChargeAmount * disControl.value) / 100;

    if (lineItemChargeAmount - (lineItemChargeAmount * this.single_staff_discount) / 100 <= netValue) {
      amtControl.setValue(netValue);
      this.inValidDiscount = false;
    } else {
      setTimeout(() => {
        this.userDiscountLimit = this.single_staff_discount;
        amtControl.setValue(lineItemChargeAmount);
        disControl.setValue(0);
        this.inValidDiscount = true;
        this.cd.detectChanges();
      }, 10);
    }
    this.cd.detectChanges();
  }

  get charges(): UntypedFormArray {
    return this.fgProducts.get('charges') as UntypedFormArray;
  }

  get deposits(): UntypedFormArray {
    return this.fgProducts.get('deposits') as UntypedFormArray;
  }

  get products(): UntypedFormArray {
    return this.fgProducts.get('products') as UntypedFormArray;
  }

  ordinal_suffix_of(i: any) {
    const j = i % 10;
    const k = i % 100;
    if (j == 1 && k != 11) {
      return i + 'st';
    }
    if (j == 2 && k != 12) {
      return i + 'nd';
    }
    if (j == 3 && k != 13) {
      return i + 'rd';
    }
    return i + 'th';
  }

  getTotalBaseCost(serviceBreakUp: ServiceBreakUp[]): number {
    return serviceBreakUp?.reduce(function (acc, obj) {
      return acc + obj.base_cost_in_minor_currency;
    }, 0);
  }

  getTotal(serviceBreakUp: ServiceBreakUp[]): string {
    return serviceBreakUp
      .reduce(function (acc, obj) {
        return acc + obj.taxable_cost_in_minor_currency;
      }, 0)
      .toString();
  }

  getTotalTaxAmount(serviceBreakUp: ServiceBreakUp[]): number {
    let taxAmount = 0;
    serviceBreakUp?.forEach((value: ServiceBreakUp) => {
      if (value.tax)
        taxAmount =
          taxAmount +
          value.tax.reduce(function (acc, obj) {
            return acc + obj.amt_in_minor_currency;
          }, 0);
    });

    return taxAmount;
  }

  getTaxAmount(tax: TaxLineItemBreakUp[]): number {
    let taxAmount = 0;
    if (tax)
      taxAmount = tax.reduce(function (acc, obj) {
        return acc + obj.amt_in_minor_currency;
      }, 0);
    return taxAmount;
  }

  getTotalChargeTaxAmount(charge: ChargeBreakUp[]): number {
    let taxAmount = 0;
    charge.forEach((value: ChargeBreakUp) => {
      if (value.tax != null)
        taxAmount =
          taxAmount +
          value.tax.reduce(function (acc, obj) {
            return acc + obj.amt_in_minor_currency;
          }, 0);
    });
    return taxAmount;
  }

  getTotalDepositTaxAmount(deposit: Deposit[]): number {
    let taxAmount = 0;
    if(deposit && deposit.length > 0)
    {
      deposit.forEach((deposit) => {
        taxAmount = taxAmount + deposit.services.reduce(
          (acc, obj) => {
            return (
              acc + this.getTaxAmount(obj.tax)
            )
          },
          0
        );
      })
    }
    return taxAmount;
  }

  getTotalProductTaxAmount(product: RetailProduct[]): number {
    let taxAmount = 0;
    product.forEach((value: RetailProduct) => {
      if (value.tax != null)
        taxAmount = taxAmount + value.tax.reduce(function (acc, obj) {
          return acc + obj.amt_in_minor_currency;
        }, 0);
    });
    return taxAmount;
  }

  getConcatStringfromArray(serviceBreakUp: PlanMasterServices[]): string {
    const cats = serviceBreakUp
      ?.map((item) => {
        return item.name_primary_language;
      })
      .join('+ ');
    return cats;
  }

  StaffDiscountCancel() {
    this.showSkeletonForBillDetails$.next(true);
    this.applyDiscount = false;
    this.inValidDiscount = false;
    this.inValidRecurringDiscount = false;
    this.RecurringDiscountReason.setValue('');
    this.ChargesDiscountReason.setValue('');
    this.RecurringDiscountReason.removeValidators([Validators.required]);
    this.ChargesDiscountReason.removeValidators([Validators.required]);
    this.cd.detectChanges();
    this.planBreakUpCalculation$.subscribe(
      (_objResponse: PlanBreakUpCalculation | null) => {
        if (_objResponse) {
          this.netCost$.subscribe((obj: number) => {
            this.firstTimeAmount =
              this.commonService.ConvertAmountFromMinorCurrency(obj);
            if (
              this.getTotalBaseCost(
                _objResponse.charging_today.service_first_charge.services
              ) -
              this.commonService.ConvertMinorCurrencyFromAmount(
                this.firstTimeAmount
              ) ==
              0
            ) {
              this.firstTimeDiscount = 0;
            } else {
              this.firstTimeDiscount =
                100 -
                (this.commonService.ConvertMinorCurrencyFromAmount(
                  this.firstTimeAmount
                ) *
                  100) /
                this.getTotalBaseCost(
                  _objResponse.charging_today.service_first_charge.services
                );
            }
          });

          this.nonRecurringNetCost$.subscribe((obj: number) => {
            this.nonRecurringAmount =
              this.commonService.ConvertAmountFromMinorCurrency(obj);

            if (
              this.getTotalBaseCost(
                _objResponse.charging_today.service_non_recurring.services
              ) -
              this.commonService.ConvertMinorCurrencyFromAmount(
                this.nonRecurringAmount
              ) ==
              0
            ) {
              this.nonRecurringDiscount = 0;
            } else {
              this.nonRecurringDiscount =
                100 -
                (this.commonService.ConvertMinorCurrencyFromAmount(
                  this.nonRecurringAmount
                ) *
                  100) /
                this.getTotalBaseCost(
                  _objResponse.charging_today.service_non_recurring.services
                );
            }
          });

          this.baseCostRecurring$.subscribe((obj: number) => {
            this.recurringMembershipAmount =
              this.commonService.ConvertAmountFromMinorCurrency(obj);

            if (
              this.getTotalBaseCost(_objResponse.charging_recurring.services) -
              this.commonService.ConvertMinorCurrencyFromAmount(
                this.recurringMembershipAmount
              ) ==
              0
            ) {
              this.recurringMembershipDiscount = 0;
            } else {
              this.recurringMembershipDiscount =
                100 -
                (this.commonService.ConvertMinorCurrencyFromAmount(
                  this.recurringMembershipAmount
                ) *
                  100) /
                this.getTotalBaseCost(
                  _objResponse.charging_recurring.services
                );
            }
          });

          const frmCharges: UntypedFormGroup = (
            this.fgProducts.controls.charges as UntypedFormArray
          ).controls[0] as UntypedFormGroup;
          const controlIds: Array<number> = [];

          Object.keys(frmCharges.controls).forEach((key) => {
            if (
              !controlIds.includes(
                parseInt(key.substring(key.indexOf('_') + 1))
              )
            )
              controlIds.push(parseInt(key.substring(key.indexOf('_') + 1)));
          });

          _objResponse.charging_today.signup_charges.forEach(
            (value: ChargeBreakUp) => {
              controlIds.forEach((val) => {
                if (value.id.toString() == val.toString()) {
                  frmCharges.controls['charges_' + val.toString()].setValue(
                    this.commonService.ConvertAmountFromMinorCurrency(
                      this.getChargeNetCost(value)
                    )
                  );
                  if (
                    frmCharges.controls['chargesbasecost_' + val.toString()]
                      .value -
                    this.getChargeNetCost(value) ==
                    0
                  ) {
                    frmCharges.controls['discount_' + val.toString()].setValue(
                      0
                    );
                  } else {
                    frmCharges.controls['discount_' + val.toString()].setValue(
                      100 -
                      (this.getChargeNetCost(value) * 100) /
                      frmCharges.controls[
                        'chargesbasecost_' + val.toString()
                      ].value
                    );
                  }
                }
              });
            }
          );

          // Handle products reset logic
          if (_objResponse.charging_today.products && _objResponse.charging_today.products.length > 0) {
            const frmProducts: UntypedFormGroup = (
              this.fgProducts.controls.products as UntypedFormArray
            ).controls[0] as UntypedFormGroup;
            const productControlIds: Array<number> = [];

            Object.keys(frmProducts.controls).forEach((key) => {
              if (
                !productControlIds.includes(
                  parseInt(key.substring(key.indexOf('_') + 1))
                )
              )
                productControlIds.push(parseInt(key.substring(key.indexOf('_') + 1)));
            });

            _objResponse.charging_today.products.forEach(
              (value: any) => {
                productControlIds.forEach((val) => {
                  if (value.sku_id.toString() == val.toString()) {
                    frmProducts.controls['product_' + val.toString()].setValue(
                      this.commonService.ConvertAmountFromMinorCurrency(
                        this.getProductNetCost(value)
                      )
                    );
                    if (
                      frmProducts.controls['productbasecost_' + val.toString()]
                        .value -
                      this.getProductNetCost(value) ==
                      0
                    ) {
                      frmProducts.controls['productdiscount_' + val.toString()].setValue(
                        0
                      );
                    } else {
                      frmProducts.controls['productdiscount_' + val.toString()].setValue(
                        100 -
                        (this.getProductNetCost(value) * 100) /
                        frmProducts.controls[
                          'productbasecost_' + val.toString()
                        ].value
                      );
                    }
                  }
                });
              }
            );
          }
        }
        this.showSkeletonForBillDetails$.next(false);
        this.cd.detectChanges();
      }
    );
  }

  async StaffDiscountBreakup() {
    this.applyDiscountBtnLoading = true;
    const firstChargeDiscApplied= this.isValidFirstChargeForm();
    const firstNonrecurrserviceApplied = this.isValidFirstServiceChargeForm();
    const chargesDiscApplied = this.isValidFormForDiscount();
    const recurringDiscApplied = this.isValidFormForRecurringDiscount();
    if (firstChargeDiscApplied || chargesDiscApplied || firstNonrecurrserviceApplied) {
      this.ChargesDiscountReason.addValidators([Validators.required]);
    }
    else{
      this.ChargesDiscountReason.removeValidators([Validators.required]);
    }

    if(recurringDiscApplied){
      this.RecurringDiscountReason.addValidators([Validators.required]);
    }
    else this.RecurringDiscountReason.removeValidators([Validators.required]);
    
    this.ChargesDiscountReason.updateValueAndValidity();
    this.ChargesDiscountReason.markAsTouched();
    this.RecurringDiscountReason.updateValueAndValidity();
    this.RecurringDiscountReason.markAsTouched();
    this.cd.detectChanges();

    // if(!firstChargeDiscApplied && !chargesDiscApplied && !firstNonrecurrserviceApplied && !recurringDiscApplied){
    //   this.applyDiscountBtnLoading = false;
    //   this.toastMessageService.showWarning('Please enter discount');
    //   this.cd.detectChanges();
    //   return;
    // }

    if (this.ChargesDiscountReason && this.ChargesDiscountReason.invalid) {
      this.ChargesDiscountReason.markAsTouched();
      if (this.isContract$.getValue() && this.RecurringDiscountReason && this.RecurringDiscountReason.invalid) {
        this.RecurringDiscountReason.markAsTouched();
      }
      this.applyDiscountBtnLoading = false;
      this.cd.detectChanges();
      return;
    }
    if (this.isContract$.getValue() && this.RecurringDiscountReason && this.RecurringDiscountReason.invalid) {
      this.RecurringDiscountReason.markAsTouched();
      this.applyDiscountBtnLoading = false;
      this.cd.detectChanges();
      return;
    }
    this.showSkeletonForBillDetails$.next(true);
    const startDate = new Date(new Date(this.subscriptionStartdate.value).setHours(0, 0, 0));
    this.discountApplied = true;
    this.applyDiscount = false;
    const staffDiscountCalculationRequest = {} as StaffDiscountCalculationRequest;
    const staffDiscountChargeRecurring = {} as StaffDiscountChargeRecurring;
    const staffDiscountChargingTodayRequest = {} as StaffDiscountChargingTodayRequest;
    const staffDiscountSignUpChargeRequest: StaffDiscountSignUpChargeRequest[] = [];

    staffDiscountChargingTodayRequest.service_first_charge = {} as StaffDiscountServiceFirstChargeRequest;
    staffDiscountChargingTodayRequest.service_non_recurring = {} as StaffDiscountServiceNonRecurringRequest;
    staffDiscountChargeRecurring.service_recurring = {} as StaffDiscountServiceRecurringRequest;
    staffDiscountCalculationRequest.client_id = this.clientId;
    staffDiscountCalculationRequest.subscription_bill_cycle_day = this.getBillingCycleDay();
    staffDiscountCalculationRequest.issue_date = this.timeService.ConvertLocalDateTimeToUTC(this.billDate.value);
    staffDiscountCalculationRequest.subscription_start_date = this.timeService.ConvertLocalDateTimeToUTC(startDate);
    staffDiscountChargingTodayRequest.service_first_charge.discount_amt_in_minor_currency = 0;
    staffDiscountChargingTodayRequest.service_non_recurring.discount_amt_in_minor_currency = 0;
    staffDiscountChargeRecurring.service_recurring.discount_amt_in_minor_currency = 0;


    if (this.frmFirstTimeBaseCostAmount)
      staffDiscountChargingTodayRequest.service_first_charge.discount_amt_in_minor_currency =
        this.frmFirstTimeBaseCostAmount - Math.round(this.commonService.ConvertMinorCurrencyFromAmount(this.firstTimeAmount));

    if (this.frmNonRecurringBaseCostAmount)
      staffDiscountChargingTodayRequest.service_non_recurring.discount_amt_in_minor_currency =
        this.frmNonRecurringBaseCostAmount - Math.round(this.commonService.ConvertMinorCurrencyFromAmount(this.nonRecurringAmount));

    if (this.recurringMembershipBaseCost)
      staffDiscountChargeRecurring.service_recurring.discount_amt_in_minor_currency =
        this.recurringMembershipBaseCost - Math.round(this.commonService.ConvertMinorCurrencyFromAmount(this.recurringMembershipAmount));

    staffDiscountCalculationRequest.charging_recurring = staffDiscountChargeRecurring;

    if (this.billingSignupMode == SignUpMode.Upgrade || this.billingSignupMode.toString() == SignUpMode[SignUpMode.Upgrade]) {
      staffDiscountCalculationRequest.upgrade_from_subscription_id = this.fromSubscription.id;
    }

    const frmCharges: UntypedFormGroup = (this.fgProducts.controls.charges as UntypedFormArray).controls[0] as UntypedFormGroup;
    const controlIds: Array<number> = [];

    //get charges control id.
    Object.keys(frmCharges.controls).forEach((key) => {
      if (!controlIds.includes(parseInt(key.substring(key.indexOf('_') + 1))))
        controlIds.push(parseInt(key.substring(key.indexOf('_') + 1)));
    });

    staffDiscountChargingTodayRequest.signup_charges = [];

    controlIds.forEach((val) => {
      const staffDiscountSignupCharge = {} as StaffDiscountSignUpChargeRequest;
      staffDiscountSignupCharge.id = val;
      staffDiscountSignupCharge.discount_amt_in_minor_currency = Math.max(0, frmCharges.controls['chargesbasecost_' + val.toString()].value -
        Math.round(this.commonService.ConvertMinorCurrencyFromAmount(frmCharges.controls['charges_' + val.toString()].value)));

      staffDiscountSignUpChargeRequest.push(staffDiscountSignupCharge);
      staffDiscountChargingTodayRequest.signup_charges = staffDiscountSignUpChargeRequest;
    });

    //get deposit control ids

    const formDeposits: UntypedFormGroup = (
      this.fgProducts.controls.deposits as UntypedFormArray
    ).controls[0] as UntypedFormGroup;
    const depositControlIds: Array<number> = [];

    if (formDeposits != undefined)
      Object.keys(formDeposits.controls).forEach((key) => {
        if (!depositControlIds.includes(parseInt(key.substring(key.indexOf('_') + 1))))
          depositControlIds.push(parseInt(key.substring(key.indexOf('_') + 1)));
      });

    const _objResponse = this.planBreakUpCalculation$.getValue() as PlanBreakUpCalculation;
    staffDiscountChargingTodayRequest.deposit = [];
    _objResponse.charging_today.deposit.forEach((val: Deposit) => {
      const staffDiscountDeposit = {} as StaffDiscountDespositRequest;
      staffDiscountDeposit.deposit_id = val.deposit_id;
      staffDiscountDeposit.deposit_internal_id = val.deposit_internal_id;
      staffDiscountDeposit.discount_amt_in_minor_currency = Math.max(0, formDeposits.controls['despositbasecost_' + val.deposit_internal_id].value -
        Math.round(this.commonService.ConvertMinorCurrencyFromAmount(formDeposits.controls['deposit_' + val.deposit_internal_id].value)));

      staffDiscountChargingTodayRequest.deposit.push(staffDiscountDeposit);
    });

    //get product control ids
    const formProducts: UntypedFormGroup = (
      this.fgProducts.controls.products as UntypedFormArray
    ).controls[0] as UntypedFormGroup;
    const productControlIds: Array<number> = [];

    if (formProducts != undefined)
      Object.keys(formProducts.controls).forEach((key) => {
        if (!productControlIds.includes(parseInt(key.substring(key.indexOf('_') + 1))))
          productControlIds.push(parseInt(key.substring(key.indexOf('_') + 1)));
      });

    // Initialize products array if it doesn't exist
    if (!staffDiscountChargingTodayRequest.products) {
      staffDiscountChargingTodayRequest.products = [];
    }

    // Process products if they exist
    if (_objResponse.charging_today.products && _objResponse.charging_today.products.length > 0) {
      _objResponse.charging_today.products.forEach((val: any) => {
        const staffDiscountProduct = {} as any; // Using any for now since we don't have the interface
        staffDiscountProduct.sku_id = val.sku_id;
        staffDiscountProduct.discount_amt_in_minor_currency = Math.max(0, formProducts.controls['productbasecost_' + val.sku_id].value -
          Math.round(this.commonService.ConvertMinorCurrencyFromAmount(formProducts.controls['product_' + val.sku_id].value)));

        staffDiscountChargingTodayRequest.products.push(staffDiscountProduct);
      });
    }

    staffDiscountCalculationRequest.charging_today = staffDiscountChargingTodayRequest;
    staffDiscountCalculationRequest.service_id = this.selectedAddons.value.map(o => o.id);

    if (this.billingSignupMode == SignUpMode.Upgrade || this.billingSignupMode.toString() == SignUpMode[SignUpMode.Upgrade]) {
      this.upgradeService.getUpgradeStaffDiscountCalculation(this.tenantId, this.subscriptionPlanId, staffDiscountCalculationRequest)
        .subscribe({
          next: (_objResponse: PlanBreakUpCalculationResponse) => {
            this.planBreakUpCalculationResponse$.next(_objResponse);
            this.planBreakUpCalculation$.next(_objResponse.plan_breakup_calculation);
            this.upgradePlanBreakUpCalculationResponse$.next(_objResponse);
            this.overLappingSubscriptionSignUp$.next(_objResponse.overlapping_subscription);
            this.showSkeletonForBillDetails$.next(false);
            this.applyDiscountBtnLoading = false;
            this.cd.detectChanges();
          },
          error: (error: AppErrors) => {
            this.toastMessageService.showError(error);
            this.showSkeleton$.next(false);
            this.showSkeletonForBillDetails$.next(false);
            this.applyDiscountBtnLoading = false;
            this.cd.detectChanges();
          },
        });
    }
    else {
      this.plansubscriptionService.getStaffDiscountCalculation(this.tenantId, this.subscriptionPlanId, staffDiscountCalculationRequest)
        .subscribe({
          next: (_objResponse: PlanBreakUpCalculationResponse) => {
            this.planBreakUpCalculationResponse$.next(_objResponse);
            this.planBreakUpCalculation$.next(_objResponse.plan_breakup_calculation);
            this.overLappingSubscriptionSignUp$.next(_objResponse.overlapping_subscription);
            this.showSkeletonForBillDetails$.next(false);
            this.applyDiscountBtnLoading = false;
            this.cd.detectChanges();
          },
          error: (error: AppErrors) => {
            this.toastMessageService.showError(error);
            this.showSkeleton$.next(false);
            this.showSkeletonForBillDetails$.next(false);
            this.applyDiscountBtnLoading = false;
            this.cd.detectChanges();
          },
        });
    }
  }

  isFormControlsDirty(form: UntypedFormGroup): boolean {
    return Object.keys(form.controls).some((key) => {
      const control = form.get(key);
      if (control == null || control == undefined) return false;
      else return control.dirty;
    });
  }

  isValidFirstChargeForm() {
    if(this.fgProducts.controls['frmFirstTimeDis'] && this.fgProducts.controls['frmFirstTimeDis'].dirty)
      return true;
    else if(this.fgProducts.controls['frmFirstTimeAmt'] && this.fgProducts.controls['frmFirstTimeAmt'].dirty)
      return true;
    else return false;
  }

  isValidFirstServiceChargeForm() {
    if(this.fgProducts.controls['frmNonRecurringAmt'] && this.fgProducts.controls['frmNonRecurringAmt'].dirty)
      return true;
    else if(this.fgProducts.controls['frmNonRecurringDis'] && this.fgProducts.controls['frmNonRecurringDis'].dirty)
      return true;
    else return false;
  }

  isValidFormForDiscount() {
    const checkControlChanges = (form: UntypedFormGroup) => {
      if (!form) return false;
      return Object.keys(form.controls).some(key => {
        const control = form.get(key);
        if (control == null || control == undefined) return false;
        else return control.dirty
      });
    };

    const chargesForm = (this.fgProducts.controls.charges as UntypedFormArray).controls[0] as UntypedFormGroup;
    const depositsForm = (this.fgProducts.controls.deposits as UntypedFormArray).controls[0] as UntypedFormGroup;
    return checkControlChanges(chargesForm) || checkControlChanges(depositsForm);
  }

  isValidFormForRecurringDiscount() {
    const frmRecurring: UntypedFormGroup = this.fgProductsRecurring;
    let hasValueChanged = false;
    hasValueChanged = Object.keys(frmRecurring.controls).some(key => {
      const control = frmRecurring.get(key);
      if (control == null || control == undefined) return false;
      else return control.dirty && control.value != 0;
    });
      return hasValueChanged;
  }

  async GetRevisedPrice_OnStartDateChange() {
    if (this.discountApplied) {
      this.changeEvent = 'StartDateChange';
      this.confirmDialog();
    }
    else {
      this.changeEvent = "";
      this.GetPlanBreakupOnSubscriptionStartDateChange();
    }
  }

  GetPlanBreakupOnSubscriptionStartDateChange() {
    this.fgProducts.controls.charges = new UntypedFormArray([]);
    this.subsStartDateValue = this.subscriptionStartdate.value;
    this.subscriptionStartdate.value.setHours(this.billDate.value.getHours());
    this.subscriptionStartdate.value.setMinutes(this.billDate.value.getMinutes());
    this.subscriptionStartdate.value.setSeconds(this.billDate.value.getSeconds());
    this.subscriptionStartdate.value.setMilliseconds(this.billDate.value.getMilliseconds());
    this.SetBillingCycle();
    this.isStartDateChanged = true;
    this.bindPlanBreakUp(this.tenantId, this.subscriptionPlanId, this.clientId);
  }

  async GetRevisedPrice_OnCycleChange() {
    if (this.discountApplied) {
      this.changeEvent = 'BillingDateChange';
      this.confirmDialog();
    }
    else {
      this.changeEvent = "";
      this.GetPlanBreakupOnBillingDateChange();
    }
  }

  GetPlanBreakupOnBillingDateChange() {
    this.fgProducts.controls.charges = new UntypedFormArray([]);
    this.billingDateValue = this.billDate.value;
    this.subscriptionStartdate.value.setHours(this.billDate.value.getHours());
    this.subscriptionStartdate.value.setMinutes(
      this.billDate.value.getMinutes()
    );
    this.subscriptionStartdate.value.setSeconds(this.billDate.value.getSeconds());
    this.subscriptionStartdate.value.setMilliseconds(this.billDate.value.getMilliseconds());
    this.isStartDateChanged = false;
    this.bindPlanBreakUp(this.tenantId, this.subscriptionPlanId, this.clientId);
  }

  getBillingCycleDay(): number {
    let day = 0;
    const startDate = new Date(new Date(this.subscriptionStartdate.value).setHours(0, 0, 0));
    if ((this.subscription_category$.value.toString() == PlanCategory.DropIn.toString() || this.subscription_category$.value == PlanCategory[PlanCategory.DropIn])
      ||
      (this.subscription_category$.value.toString() == PlanCategory.PaidInFull.toString() || this.subscription_category$.value == PlanCategory[PlanCategory.PaidInFull])
    ) {
      //day = parseInt((this.timeService.ConvertLocalDateTimeToUTC(startDate).split("T")[0]).split("-")[2]);
      day = 0;
    }
    else if ((this.subscription_category$.value.toString() == PlanCategory.PayAsYouGo.toString() || this.subscription_category$.value == PlanCategory[PlanCategory.PayAsYouGo])
      || (this.subscription_category$.value.toString() == PlanCategory.Contract.toString() || this.subscription_category$.value == PlanCategory[PlanCategory.Contract])) {
      if (this.planDetail.billing_interval_type.toString() == PlanIntervalType.Week.toString() || this.planDetail.billing_interval_type.toString() == PlanIntervalType[PlanIntervalType.Week]
        || this.planDetail.billing_interval_type.toString() == PlanIntervalType.Month.toString() || this.planDetail.billing_interval_type.toString() == PlanIntervalType[PlanIntervalType.Month]) {
        //day = this.billingCycle.value.value;
        if (this.billingCycle.value.isSignup)
          day = 0;
        else
          day = this.billingCycle.value.value;
      }
      else {
        day = parseInt((this.timeService.ConvertLocalDateTimeToUTC(startDate).split("T")[0]).split("-")[2]);
      }
    }
    else {
      if (this.billingCycle.value.isSignup)
        day = 0; //parseInt((this.timeService.ConvertLocalDateTimeToUTC(startDate).split("T")[0]).split("-")[2]);
      else {
        day = this.billingCycle.value.value
      }
    }
    return day;
  }

  isPlanBehaviourRecurring(planCategory: string): boolean {
    return (
      planCategory == PlanCategory.Contract.toString() ||
      planCategory == PlanCategory[PlanCategory.Contract] ||
      planCategory == PlanCategory.PayAsYouGo.toString() ||
      planCategory == PlanCategory[PlanCategory.PayAsYouGo]
    );
  }

  ApplyCoupon() {
    if (this.discountApplied) {
      this.alreadyDiscountApplied.next(true);
      this.applyCoupon = false;
    } else {
      this.applyCoupon = true;
      this.alreadyDiscountApplied.next(false);
      this.applyCouponModal = true;
    }
  }

  AddCouponCode(couponCode: string, byTextBox: boolean) {
    if (couponCode != null || couponCode != '') {
      this.couponCodeFormControl.setValue(couponCode);
      if (byTextBox) this.couponCode = couponCode;
      else this.couponCode = "";
    }
    else {
      this.couponCodeFormControl.setValue('');
      this.couponCode = "";
    }
    this.applyCoupon = false;
    this.applyCouponModal = false;
    if (this.couponCodeFormControl.value != '') {
      this.couponApplied = true;
      this.isCouponApplied.next(true);
      this.bindPlanBreakUp(
        this.tenantId,
        this.subscriptionPlanId,
        this.clientId
      );
    } else {
      this.couponApplied = false;
      this.isCouponApplied.next(false);
      this.inValidCoupon.next(false);
      this.bindPlanBreakUp(
        this.tenantId,
        this.subscriptionPlanId,
        this.clientId
      );
    }
  }


  closeCouponPopup() {
    this.couponCode = "";
    this.applyCoupon = false;
    this.couponApplied = false;
    this.isCouponApplied.next(false);
    this.inValidCoupon.next(false);
    this.alreadyDiscountApplied.next(false);
    this.applyCouponModal = false;
    this.bindPlanBreakUp(this.tenantId, this.subscriptionPlanId, this.clientId);
  }

  RemoveCouponCode(callPlanBreakUp: boolean) {
    this.applyCoupon = false;
    this.couponApplied = false;
    this.isCouponApplied.next(false);
    this.inValidCoupon.next(false);
    this.couponCode = "";
    this.alreadyDiscountApplied.next(false);
    this.couponCodeFormControl.setValue('');
    if (callPlanBreakUp) this.bindPlanBreakUp(this.tenantId, this.subscriptionPlanId, this.clientId);
  }

  ApplyDiscount() {
    if (this.couponApplied) {
      this.alreadyDiscountApplied.next(true);
      this.applyDiscount = false;
    } else {
      this.applyDiscount = true;
      this.alreadyDiscountApplied.next(false);
      //this.RecurringDiscountReason.addValidators([Validators.required]);
      //this.ChargesDiscountReason.addValidators([Validators.required]);
    }
  }

  RemoveDiscount(): void {
    this.showSkeletonForBillDetails$.next(true);
    const chargesForm = (this.fgProducts.controls.charges as UntypedFormArray).controls[0] as UntypedFormGroup;
    const depositsForm = (this.fgProducts.controls.deposits as UntypedFormArray).controls[0] as UntypedFormGroup;
    if(chargesForm) chargesForm.reset();
    if(depositsForm) depositsForm.reset();
    this.fgProducts.get('frmFirstTimeAmt')?.setValue(0);
    this.firstTimeDiscountFormControl.reset();
    this.fgProducts.controls.frmNonRecurringAmt.setValue(0);
    this.fgProducts.controls.frmNonRecurringDis.setValue(0);
    this.fgProducts.controls.frmNonRecurringTaxAmt.setValue(0);
    Object.keys(this.fgProductsRecurring.controls).forEach(key => {
      const control = this.fgProductsRecurring.get(key);
      control?.setValue(0);
    });
    Object.keys(this.fgProducts.controls.charges).forEach(key => {
      const control = this.fgProductsRecurring.get(key);
      control?.setValue(0);
    });
    this.RecurringDiscountReason.reset();
    this.ChargesDiscountReason.reset();
    this.RecurringDiscountReason.removeValidators([Validators.required]);
    this.ChargesDiscountReason.removeValidators([Validators.required]);
    this.cd.detectChanges();
    this.bindPlanBreakUp(this.tenantId, this.subscriptionPlanId, this.clientId);
  }

  SelectAddon() {
    if (this.discountApplied) {
      this.changeEvent = 'Addon';
      this.confirmDialog();
    }
    else
      this.showAddonsSidebar = true;
  }

  closeAddonSidebar(event: any) {
    this.showAddonsSidebar = false;
    this.selectedAddons.next(event.selectedAddons);
    if (this.selectedAddons.value.length > 0 && event.callbreakup) this.bindPlanBreakUp(this.tenantId, this.subscriptionPlanId, this.clientId);
  }

  PosDeviceSignup() {
    if (this.disablePosButton.value) return;
    this.isSubmitting.next(true);
    this.fg.markAllAsTouched();
    if (this.inValidCoupon.getValue() || this.inValidDiscount || this.inValidRecurringDiscount) {
      this.isSubmitting.next(false);
      return;
    }

    if (this.keyFobRequired && this.keyFobFormControl.invalid) {
      this.keyFobFormControl.markAsDirty();
      this.isSubmitting.next(false);
      this.cd.detectChanges();
      return;
    }
    if (this.stateService.getPaymentGatewayList().length > 0) {
      this.paymentGatewayList.next(this.stateService.getPaymentGatewayList());
      this.checkPaymentGateways();
      this.cd.detectChanges();
    }
    else {
      this.paymentGatewayMasterService.getPaymentGatewayMasters(this.tenantId).subscribe(
        {
          next: (res: any) => {
            this.paymentGatewayList.next((res.items ? res.items : []));
            this.stateService.setPaymentGatewayList(this.paymentGatewayList.value);
            this.checkPaymentGateways();
            this.cd.detectChanges();
          }, error: (error: any) => {
            this.posDeviceList.next(([]));
            this.paymentGatewayList.next(([]));
            this.stateService.setPaymentGatewayList(this.paymentGatewayList.value);
            this.toastMessageService.showError(error);
            this.isSubmitting.next(false);
            this.cd.detectChanges();
          }
        });
    }
  }

  checkPaymentGateways() {
    if (this.paymentGatewayList.value.length > 0) {
      this.paymentGateway = this.paymentGatewayList.value.find(o => (o.payment_gateway == PaymentGatewaySupported.PayenginCanada || o.payment_gateway.toString() == PaymentGatewaySupported[PaymentGatewaySupported.PayenginCanada])
        || (o.payment_gateway == PaymentGatewaySupported.PayenginUSA || o.payment_gateway.toString() == PaymentGatewaySupported[PaymentGatewaySupported.PayenginUSA]))!;

      if (this.paymentGateway && this.paymentGateway.id > 0) {
        this.getDeviceList();
      }
      else {
        this.toastMessageService.showErrorMessage('Required payment gateway is not configured');
        this.isSubmitting.next(false);
        this.cd.detectChanges();
      }
    }
    else {
      this.isSubmitting.next(false);
      this.toastMessageService.showErrorMessage('No payment gateway configured');
      this.cd.detectChanges();
    }
  }

  getDeviceList() {
    if (this.stateService.getDeviceList().length > 0) {
      this.posDeviceList.next(this.stateService.getDeviceList());
      this.posDeviceListResponsehandle();
      this.cd.detectChanges();
    }
    else {
      this.tenantService.GetTenantPosDevicesById(this.tenantId, this.paymentGateway.payment_gateway).subscribe(
        {
          next: (res: any) => {
            this.posDeviceList.next((res.items ? res.items as PosDeviceDetails[] : []));
            this.stateService.setDeviceList(this.posDeviceList.value);
            this.posDeviceListResponsehandle();
            this.cd.detectChanges();
          }, error: (error: any) => {
            this.posDeviceList.next(([]));
            this.paymentGatewayList.next(([]));
            this.stateService.setDeviceList(this.posDeviceList.value);
            this.toastMessageService.showError(error);
            this.isSubmitting.next(false);
            this.cd.detectChanges();
          }
        });
    }

  }

  posDeviceListResponsehandle() {
    if (this.posDeviceList.value.length > 0) {
      if (this.posDeviceList.value.length > 1)
        this.showDeviceList = true;
      else {
        const device: PosDeviceSale = {} as PosDeviceSale;
        device.merchant_id = this.paymentGateway.merchant_id;
        device.payment_gateway_supported = this.paymentGateway.payment_gateway;
        device.sale_device_id = this.posDeviceList.value[0].device_id;
        this.posDeviceSale = device;
        const paymentSignUp = {} as PaymentSignUp;
        this.transactionInProcess = true;
        this.SaveSubscription(false, paymentSignUp);
      }
    }
    else {
      this.toastMessageService.showErrorMessage('No device configured');
      this.isSubmitting.next(false);
      this.cd.detectChanges();
    }
  }

  closeDevicesPopup(event: any) {
    if (event.selectedDevice && event.selectedDevice != null) {
      const device: PosDeviceSale = {} as PosDeviceSale;
      device.merchant_id = this.paymentGateway.merchant_id;
      device.payment_gateway_supported = this.paymentGateway.payment_gateway;
      device.sale_device_id = event.selectedDevice.device_id;
      this.posDeviceSale = device;
      const paymentSignUp = {} as PaymentSignUp;
      this.transactionInProcess = true;
      this.SaveSubscription(false, paymentSignUp);
    }
    this.showDeviceList = false;
    this.isSubmitting.next(false);
    this.cd.detectChanges();
  }

  RetryPayment() {
    this.paymentFailed = false;
    this.transactionInProcess = true;
    const paymentSignUp = {} as PaymentSignUp;
    this.SaveSubscription(false, paymentSignUp);
  }

  toggleKeyFobSelectionType(digitalKeyFOBSelected: boolean, physicalKeyFOBSelected: boolean) {
    this.digitalKeyFOBSelected = digitalKeyFOBSelected;
    this.physicalKeyFOBSelected = physicalKeyFOBSelected;
    if (this.physicalKeyFOBSelected) {
      this.keyFobFormControl.addValidators(Validators.required);
      this.keyFobFormControl.addValidators(Validators.pattern(this.validAlphaNumericPattern));
    }
    else {
      this.keyFobFormControl.removeValidators(Validators.required);
      this.keyFobFormControl.removeValidators(Validators.pattern(this.validAlphaNumericPattern));
      this.keyFobFormControl.clearValidators();
      this.keyFobFormControl.setErrors(null);
    }
    this.keyFobFormControl.updateValueAndValidity();
    this.cd.detectChanges();
  }

  GetClientReferrel(client: Client) {
    this.referredBy = client.clt_id;
  }

  removeClient() {
    this.referredBy = 0;
  }

  closeBillingSideBar(sGuid: string) {
    this.confirmationService.close();
    this.closeSidePopup.emit({ hideSidebar: false, clientSignupUUID: this.clientSignupUUID });
  }

  OpenOtherPayment() {
    if (this.keyFobRequired && this.keyFobFormControl.invalid) {
      this.keyFobFormControl.markAsDirty();
      this.cd.detectChanges();
    }
    else {
      this.totalOneTimeCost$.subscribe({
        next: (val: number) => {
          this.paymentAmount = val;
        }
      });
      this.showOtherPaymentsModel$.next(true);
    }
  }

  HideOtherPaymentDialog(evt: any) {
    if (evt && evt.paymentSignUp) {
      const paymentdetails = evt.paymentSignUp as PaymentSignUp;
      this.isSubmitting.next(true);
      this.SaveSubscription(true, paymentdetails);
    }
    else {
      this.showOtherPaymentsModel$.next(false);
      this.isSubmitting.next(false);
      this.cd.detectChanges();
    }
  }

  closeOtherPaymentDialog(event: any) {
    this.showOtherPaymentsModel$.next(false);
  }

  closeChangeSessionOwnerDialogEvent(event: any) {
    this.showSessionOwnerChangeModel$.next(false);
    this.planBreakUpCalculation$.next(event.planBreakUpCalculation)
  }

  ChangeBillingNameEvent(event: any) {
    this.billingName = event.billingName;
  }

  Appliedcoupon(couponCode: any): boolean {
    if (this.couponCodeFormControl.value == couponCode) return true;
    else return false;
  }


  SaveSubscription(isOfflinePayment: boolean, paymentObj: PaymentSignUp) {
    this.isSubmitting.next(true);
    this.fg.markAllAsTouched();
    if (this.inValidCoupon.getValue() || this.inValidDiscount || this.inValidRecurringDiscount) {
      this.isSubmitting.next(false);
      return;
    }

    if (this.keyFobRequired && this.keyFobFormControl.invalid) {
      this.keyFobFormControl.markAsDirty();
      this.isSubmitting.next(false);
      this.cd.detectChanges();
      return;
    }

    const signUpRequest = this.CreateSignupRequest(isOfflinePayment, paymentObj, false);
    if (this.billingSignupMode == SignUpMode.MidCycleAddons || this.billingSignupMode.toString() == SignUpMode[SignUpMode.MidCycleAddons]) {
      this.ClientSubscriptionAddons(signUpRequest);
    }
    else {
      this.ClientSubscriptionSignup(signUpRequest);
    }
  }

  ClientSubscriptionSignup(signUpRequest: SignUpRequest) {
    this.plansubscriptionService.SubscriptionSignup(this.tenantId, this.clientId, signUpRequest)
      .pipe(
        retryWhen(errors =>
          errors.pipe(
            // Check for the specific error condition that should trigger a retry
            scan((count, error) => {
              if (
                count < 2 && // Retry only 2 times
                error &&
                error.originalError.error &&
                error.originalError.error[0] &&
                error.originalError.error[0].errorCode === 'paymentamountgreaterthaninvoiceamount'
              ) {
                // Update the payload before retrying
                signUpRequest.offline_payment.amount_in_minor_currency = signUpRequest.offline_payment.rounded_amount_in_minor_currency!;
                return count + 1; // Increment the retry count
              }
              // Do not retry for other errors or after 3 retries
              throw error;
            }, 0),
            switchMap((retryCount) => timer(100))
          )
        ),
        catchError((error) => {
          return throwError(error);
        })
      )
      .subscribe({
        next: (_objResponse: SignUpResponse) => {
          this.isSubmitting.next(false);
          this.clientSignupUUID = _objResponse.clientsignupuuId;
          this.closeBillingSideBar(_objResponse.clientsignupuuId);
        },
        error: (error) => {
          this.isSubmitting.next(false);
          if (this.transactionInProcess) {
            this.transactionInProcess = false;
            this.paymentFailed = true;
          }
          else {
            this.transactionInProcess = false;
            this.paymentFailed = false;
            this.cd.detectChanges();
            this.error.next(error);
            this.errorMessages.push([]);
            this.showErrorPopup?.next(true);
            this.showOtherPaymentsModel$.next(false);
            this.cd.detectChanges();
          }
        }
      });
  }

  ClientSubscriptionAddons(signUpRequest: SignUpRequest) {
    this.plansubscriptionService.ClientSubscriptionAddon(this.tenantId, this.clientId, this.fromSubscription.id, signUpRequest)
      .pipe(
        retryWhen(errors =>
          errors.pipe(
            // Check for the specific error condition that should trigger a retry
            scan((count, error) => {
              if (
                count < 2 && // Retry only 2 times
                error &&
                error.originalError.error &&
                error.originalError.error[0] &&
                error.originalError.error[0].errorCode === 'paymentamountgreaterthaninvoiceamount'
              ) {
                // Update the payload before retrying
                signUpRequest.offline_payment.amount_in_minor_currency = signUpRequest.offline_payment.rounded_amount_in_minor_currency!;
                return count + 1; // Increment the retry count
              }
              // Do not retry for other errors or after 3 retries
              throw error;
            }, 0),
            switchMap((retryCount) => timer(100))
          )
        ),
        catchError((error) => {
          return throwError(error);
        })
      )
      .subscribe({
        next: (_objResponse: SignUpResponse) => {
          this.isSubmitting.next(false);
          this.clientSignupUUID = _objResponse.clientsignupuuId;
          this.closeBillingSideBar(_objResponse.clientsignupuuId);
        },
        error: (error) => {
          this.isSubmitting.next(false);
          if (this.transactionInProcess) {
            this.transactionInProcess = false;
            this.paymentFailed = true;
          }
          else {
            this.transactionInProcess = false;
            this.paymentFailed = false;
            this.cd.detectChanges();
            this.error.next(error);
            this.errorMessages.push([]);
            this.showErrorPopup?.next(true);
            this.showOtherPaymentsModel$.next(false);
            this.cd.detectChanges();
          }
        }
      });
  }


  addToCard()
  {
    this.isSubmitting.next(true);
    const planObject:any = {};
    const startDate = new Date(new Date(this.subscriptionStartdate.value).setHours(0, 0, 0));
      const planBreakUpCalculationRequest: PlanBreakUpCalculationRequest = {
        client_id: this.clientId,
        coupon_code: this.couponCodeFormControl.value,
        is_coupon_code_applied: this.couponApplied,
        issue_date: this.timeService.ConvertLocalDateTimeToUTC(this.billDate.value),
        subscription_bill_cycle_day: this.getBillingCycleDay(),
        subscription_start_date: this.timeService.ConvertLocalDateTimeToUTC(startDate),
        addon_service_id: this.selectedAddons.value.map(o => o.id),
        is_family_owner: this.planSummary.is_family_owner,
        sponsor_contract_id: this.planSummary.sponsor_contract_id
      };
      planObject.planBreakUpCalculationRequest = planBreakUpCalculationRequest;
      planObject.origionalData = this.planDetail;
      planObject.totalAmount =  this.getAmountWithoutExternalChargeAmount;
      planObject.billingName = this.billingName;
      this.planSummary$.subscribe({
        next: (res) => {
          planObject.planDetails = res;
          this.isSubmitting.next(false);
          this.closeBillingSideBar("");
          this.addToCart.emit({ type: 'plan', object: planObject });
        }
      });
     
  }


  CreateSignupRequest(isOfflinePayment: boolean, paymentObj: PaymentSignUp, changeAmont: boolean = false): SignUpRequest {
    let signUpRequest: SignUpRequest = {} as SignUpRequest;
    let paymentSignUp: PaymentSignUp = {} as PaymentSignUp;
    if (isOfflinePayment) {
      paymentSignUp = paymentObj;
      if (changeAmont) paymentSignUp.amount_in_minor_currency = paymentObj.rounded_amount_in_minor_currency!;
    } else {
      paymentSignUp = {} as PaymentSignUp;
    }
    let orgPlanSummary: PlanSummary = {} as PlanSummary;  
    const crm: Crm = {} as Crm;
    this.planSummary$.subscribe({
      next: (res) => {
        orgPlanSummary = res;
        crm.sigup_sts_opp_id = res?.CRM?.opp_id;
        crm.sigup_sts_tsk_id = res?.CRM?.task_id;
        crm.sigup_sts_board_type = res?.CRM?.board_id;
      },
    });

    const startDate = new Date(new Date(this.subscriptionStartdate.value).setHours(0, 0, 0, 0));
    signUpRequest = {
      plan_id: this.subscriptionPlanId,
      collected_at: this.billedAtTenantId,
      start_date: this.timeService.ConvertLocalDateTimeToUTC(startDate),
      bill_cycle_day: this.getBillingCycleDay(),
      sales_rep: this.billingOwner.value.id,
      issue_date: this.timeService.ConvertLocalDateTimeToUTC(this.billDate.value),
      billing_name: this.billingName != "" ? this.billingName : this.clientName,
      is_offline_payment: isOfflinePayment,
      offline_payment: paymentSignUp,
      is_coupon_code_applied: this.couponApplied,
      sigup_coupon_code: this.couponCodeFormControl.value,
      charging_today: {} as ChargingTodaySignUp,
      charging_recurring: {} as RecurringSignUp,
      current_keyfob: this.keyFobFormControl.value,
      crm: crm,
      referred_by: this.referredBy,
      is_digital_keyfob: this.digitalKeyFOBSelected,
      pos_device_sale: this.posDeviceSale,
      complition_target_device: this.CompilationTargetFormControl.value.value,
      is_family_owner: this.planSummary.is_family_owner,
      contract_sponsor_id: this.planSummary.sponsor_contract_id
    } as SignUpRequest;

    const _objResponse = this.planBreakUpCalculation$.getValue() as PlanBreakUpCalculation;
    const planBreakUpResponse = this.planBreakUpCalculationResponse$.getValue();
    if (this.billingSignupMode == SignUpMode.Upgrade || this.billingSignupMode.toString() == SignUpMode[SignUpMode.Upgrade]) {
      const upgradeRequest = {
        upgrade_date: this.timeService.ConvertLocalDateTimeToUTC(this.billDate.value),
        upgrade_from_subscription_id: this.fromSubscription.id,
        upgrade_diff_amount_minor_currency: planBreakUpResponse.upgrade_diff_amount,
        upgrade_from_tenant_id: this.tenantId,
        upgrade_from_total_amount_minor_currency: planBreakUpResponse.from_invoice_amount,
        upgrade_To_total_amount_minor_currency: planBreakUpResponse.total_upgrade_to_amount
      } as UpgradeSignUpRequest;

      signUpRequest.upgrade_sign_up = upgradeRequest;
      signUpRequest.signup_type = SignUpMode.Upgrade;
      const upgradeOldData = this.planSummary.planBreakupResponse?.plan_breakup_calculation;
      if (upgradeOldData?.charging_today.service_non_recurring && upgradeOldData?.charging_today.service_non_recurring.services && upgradeOldData?.charging_today.service_non_recurring.services.length > 0) {
        const services = upgradeOldData?.charging_today.service_non_recurring.services;
        _objResponse.charging_today.service_non_recurring.services.forEach(o => {
          if (services.find(s => s.id == o.id && s.category_id == o.category_id)) {
            const service = services.find(s => s.id == o.id && s.category_id == o.category_id)!;
            if (service.final_sessions) o.sessions = service.final_sessions;
            else o.sessions = service.sessions;
          }
        });
      }
    }
    else {
      signUpRequest.upgrade_sign_up = {} as UpgradeSignUpRequest;
      signUpRequest.signup_type = SignUpMode.SignUp;
    }

    signUpRequest.charging_today = _objResponse.charging_today;
    signUpRequest.charging_recurring = _objResponse.charging_recurring;
    signUpRequest.prorata_future_recurring = _objResponse.prorata_future_recurring;

    if (this.billingSignupMode == SignUpMode.MidCycleAddons || this.billingSignupMode.toString() == SignUpMode[SignUpMode.MidCycleAddons]) {
      signUpRequest.charging_today.service_first_charge_mid_addons = this.midCycleAddonBreakUpCalculationResponse$.value.charging_today_addons.service_first_charge_mid_addons;
      signUpRequest.signup_type = SignUpMode.MidCycleAddons;
    }
    // for change discount
    if (signUpRequest.charging_today && signUpRequest.charging_today.signup_charges && signUpRequest.charging_today.signup_charges.length > 0) {
      signUpRequest.charging_today.signup_charges.forEach(o => {
        o.discount_reason = this.ChargesDiscountReason.value;
      })
    }
    if (signUpRequest.charging_today && signUpRequest.charging_today.service_non_recurring
      && signUpRequest.charging_today.service_non_recurring.services && signUpRequest.charging_today.service_non_recurring.services.length > 0) {
      signUpRequest.charging_today.service_non_recurring.services.forEach(o => {
        o.discount_reason = this.ChargesDiscountReason.value;
      })
    }
    if (signUpRequest.charging_today && signUpRequest.charging_today.service_first_charge
      && signUpRequest.charging_today.service_first_charge.services && signUpRequest.charging_today.service_first_charge.services.length > 0) {
      signUpRequest.charging_today.service_first_charge.services.forEach(o => {
        o.discount_reason = this.ChargesDiscountReason.value;
      })
    }
    // for recurring discount
    if (signUpRequest.charging_recurring && signUpRequest.charging_recurring.services && signUpRequest.charging_recurring.services.length > 0) {
      signUpRequest.charging_recurring.services.forEach(o => {
        o.discount_reason = this.RecurringDiscountReason.value;
      })
    }
    return signUpRequest;
  }

  isSupportedPlan() {
    if ((this.subscription_category$.value.toString() == PlanCategory.PaidInFull.toString() || this.subscription_category$.value == PlanCategory[PlanCategory.PaidInFull])
      || (this.subscription_category$.value.toString() == PlanCategory.DropIn.toString() || this.subscription_category$.value == PlanCategory[PlanCategory.DropIn])) {
      this.disablePosButton.next(false);
      return true;
    }
    else if ((this.subscription_category$.value.toString() == PlanCategory.PayAsYouGo.toString() || this.subscription_category$.value == PlanCategory[PlanCategory.PayAsYouGo])
      || (this.subscription_category$.value.toString() == PlanCategory.Contract.toString() || this.subscription_category$.value == PlanCategory[PlanCategory.Contract])) {
      if (this.isCashRecurring) {
        this.disablePosButton.next(false);
        return true;
      }
      else {
        // this.disablePosButton.next(true); // need to apply this logic later
        this.disablePosButton.next(false);
        return true;
      }
    }
    else {
      // this.disablePosButton.next(true); // need to apply this logic later
      this.disablePosButton.next(false);
      // return false; 
      return true;
    }
  }

  getTooltip() {
    if (this.disablePosButton.value) return 'POS.MEMBERSHIP_ADDON.POS_BTN_TOOLTIP';
    else return 'POS.MEMBERSHIP_ADDON.NO_TOOLTIP';
  }

  getDisableBtnTooltip() {
    if (this.isZeroPayment()) return 'POS.MEMBERSHIP_ADDON.OFFLINE_BTN_TOOLTIP';
    else return 'POS.MEMBERSHIP_ADDON.NO_TOOLTIP';
  }

  isBtnDisabled() {
    return (this.getInvalidCoupon || this.inValidDiscount || this.inValidRecurringDiscount || this.isOverlapping || !this.isPlanSelected 
      || (this.isPayingTodayZero && this.isRecurringAmountNotZero && this.isTypeContract(this.subscription_category$.value))
      || this.isKeyfobValidationInvalid);
  }

  get isKeyfobValidationInvalid(): boolean {
    if (!this.keyFobRequired) {
      return false;
    }
    
    const currentValue = this.keyFobFormControl.value;
    const isKeyfobChanged = currentValue !== this.clientKeyfob;
    
    return this.isValidatingKeyfob || (isKeyfobChanged && !this.isKeyfobValid);
  }

  isZeroPayment() {
    return (this.isPayingTodayZero && this.isRecurringAmountNotZero && this.isTypeContract(this.subscription_category$.value));
  }

  confirmDialog() {
    let translation: any;
    this.translate.get(['POS.MEMBERSHIP_ADDON.CONFIRMATION_DILAOG', 'POS.MEMBERSHIP_ADDON.CONFIRMATION', 'common.BUTTONS.BUTTON-TEXT-YES', 'common.BUTTONS.BUTTON-TEXT-NO'])
      .subscribe((translations) => {
        translation = translations;
      });
    this.confirmationService.confirm({
      header: translation['POS.MEMBERSHIP_ADDON.CONFIRMATION'],
      message: translation['POS.MEMBERSHIP_ADDON.CONFIRMATION_DILAOG'],
      icon: 'fa fa-exclamation-triangle',
      acceptLabel: translation['common.BUTTONS.BUTTON-TEXT-YES'],
      rejectLabel: translation['common.BUTTONS.BUTTON-TEXT-NO'],
      accept: () => {
        switch (this.changeEvent) {
          case 'StartDateChange':
            {
              this.GetPlanBreakupOnSubscriptionStartDateChange();
            }
            break;
          case 'BillingDateChange':
            {
              this.GetPlanBreakupOnBillingDateChange();
            }
            break;
          case 'Addon':
            {
              this.showAddonsSidebar = true;
            }
            break;
        }
        this.cd.detectChanges();
      },
      reject: () => {
        switch (this.changeEvent) {
          case 'StartDateChange':
            {
              this.subscriptionStartdate.setValue(this.subsStartDateValue);
            }
            break;
          case 'BillingDateChange':
            {
              this.billDate.setValue(this.billingDateValue);
            }
            break;
        }
      }
    });
  }

  confirmDialogForSignupDateOverlap(signUpDate:any, formatedDate:any) {
    this.confirmationService.confirm({
      header: this.translate.instant('POS.MEMBERSHIP_ADDON.SIGNUP_DATE_OVERLAP_CONFIRMATION_HEADER'),
      message: this.translate.instant('POS.MEMBERSHIP_ADDON.SIGNUP_DATE_OVERLAP_CONFIRMATION',{date:formatedDate}),
      icon: 'fa fa-exclamation-triangle',
      acceptLabel: this.translate.instant('common.BUTTONS.BUTTON-TEXT-OK'),
      rejectVisible: false,
      accept: () => {
        this.changeEvent = 'StartDateChange';
        this.subscriptionStartdate.setValue(signUpDate);
        this.subscriptionStartdate.updateValueAndValidity();
        this.GetPlanBreakupOnSubscriptionStartDateChange();
        this.cd.detectChanges();
      }
    });
  }


  // region "get product list"
  getProductSKuDetails(productId: number) {
    const productSku = this.planSummary?.subscriptionProductsAndCharges?.products.find(o => o.sku_id == productId);
    if (productSku) {
      return productSku.product_sku;
    }
    else {
      return null;
    }
  }
  // endregion "get product list"

  //#region "getproperty"
  get planList() {
    return this.fg.controls.ddlplanSubscriptionList as UntypedFormControl;
  }

  get billingCycle() {
    return this.fg.controls.ddlBillingCycle as UntypedFormControl;
  }

  get billCycle() {
    return this.billingCycle.value;
  }

  get billingOwner() {
    return this.fg.controls.billingOwner as UntypedFormControl;
  }

  get billDate() {
    return this.fg.controls.billdate as UntypedFormControl;
  }

  get subscriptionStartdate() {
    return this.fg.controls.subscriptionstartdate as UntypedFormControl;
  }

  get couponCodeFormControl() {
    return this.fg.controls.couponCode as UntypedFormControl;
  }

  get couponCodeFormControlValue() {
    return this.couponCodeFormControl.value;
  }

  get keyFobFormControl(): UntypedFormControl {
    return this.fg.controls.keyfob as UntypedFormControl;
  }

  get CompilationTargetFormControl(): UntypedFormControl {
    return this.fg.controls["target_device"] as UntypedFormControl;
  }

  //#endregion "getproperty"

  // #region "TotalCost"

  get frmgetRecurringAmount(): number {
    return this.frmFirstTimeBaseCostAmountFormControl.value as number;
  }

  // #endregion "TotalCost"

  //#region BaseCost
  get frmFirstTimeBaseCostAmountFormControl(): UntypedFormControl {
    return this.fgProducts.controls
      .frmFirstTimeBaseCostAmt as UntypedFormControl;
  }

  get frmFirstTimeBaseCostAmount(): number {
    return this.frmFirstTimeBaseCostAmountFormControl.value as number;
  }

  set frmFirstTimeBaseCostAmount(val: number) {
    this.frmFirstTimeBaseCostAmountFormControl.setValue(val);
  }

  get frmNonRecurringBaseCostAmountFormControl(): UntypedFormControl {
    return this.fgProducts.controls
      .frmNonRecurringBaseCostAmt as UntypedFormControl;
  }

  get frmNonRecurringBaseCostAmount(): number {
    return this.frmNonRecurringBaseCostAmountFormControl.value as number;
  }

  set frmNonRecurringBaseCostAmount(val: number) {
    this.frmNonRecurringBaseCostAmountFormControl.setValue(val);
  }

  //#region BaseCost

  get recurringTotalAmount$(): number {
    const value = this.planBreakUpCalculation$.getValue();
    if (value) {
      return value.charging_recurring.services.reduce((acc, obj) => {
        return acc + obj.taxable_cost_in_minor_currency + this.getTaxAmount(obj.tax);
      }, 0);
    } else {
      return 0;
    }
  }

  get recurringCost$(): Observable<number> {
    return this.planBreakUpCalculation$.pipe(
      map((value: PlanBreakUpCalculation | null) => {
        if (value) {
          return value.charging_recurring.services.reduce( (acc, obj) => {
            return (
              acc +
              obj.taxable_cost_in_minor_currency +
              this.getTaxAmount(obj.tax)
            );
          }, 0);
        } else return 0;
      })
    );
  }

  get existingRecurringCost$(): number {
    const breakUpresponse = this.midCycleAddonBreakUpCalculationResponse$.value;
    if (breakUpresponse && breakUpresponse.existing_recurring_services) {
      return breakUpresponse.existing_recurring_services.reduce( (acc, obj) => {
        return (
          acc +
          obj.base_cost_in_minor_currency +
          this.getTaxAmount(obj.tax)
        );
      }, 0);
    }
    else { return 0 }
  }

  get addonRecurringCost$(): number {
    const breakUpresponse = this.planBreakUpCalculation$.value;
    if (breakUpresponse && breakUpresponse.charging_recurring && breakUpresponse.charging_recurring.services) {
      return breakUpresponse.charging_recurring.services.reduce((acc, obj) => {
        return (
          acc +
          obj.taxable_cost_in_minor_currency +
          this.getTaxAmount(obj.tax)
        );
      }, 0);
    }
    else { return 0 }
  }

  get netCost$(): Observable<number> {
    return this.planBreakUpCalculationResponse$.pipe(
      map((value: PlanBreakUpCalculationResponse) => {
        if (value) {
          const _value = value.plan_breakup_calculation.charging_today.service_first_charge.services?.reduce(
             (acc, obj) => {
              return (
                acc +
                this.getNetCost(
                  obj.taxable_cost_in_minor_currency,
                  this.getTaxAmount(obj.tax)
                )
              );
            },
            0
          );
          return (_value == 0) ? 0.00000000001 : _value;
        } else {
          return 0;
        }
      })
    );
  }

  get nonRecurringNetCost$(): Observable<number> {
    return this.planBreakUpCalculationResponse$.pipe(
      map((value: PlanBreakUpCalculationResponse) => {
        if (value) {
          if(value.plan_breakup_calculation.charging_today.service_non_recurring.services)
          {
            return value.plan_breakup_calculation.charging_today.service_non_recurring.services.reduce(
              (acc, obj) => {
                return (
                  acc +
                  this.getNetCost(
                    obj.taxable_cost_in_minor_currency,
                    this.getTaxAmount(obj.tax)
                  )
                );
              },
              0
            );
          }
          else return 0;
        } else return 0;
      })
    );
  }

  getChargeNetCost(charge: ChargeBreakUp): number {
    return this.getNetCost(
      charge.taxable_cost_in_minor_currency,
      this.getTaxAmount(charge.tax)
    );
  }

  getProductNetCost(product: any): number {
    return this.getNetCost(
      product.taxable_cost_in_minor_currency,
      this.getTaxAmount(product.tax)
    );
  }

  get netCostRecurring$(): Observable<number> {
    return this.planBreakUpCalculationResponse$.pipe(
      map((value: PlanBreakUpCalculationResponse) => {
        if (value) {
          return value.plan_breakup_calculation.charging_recurring.services.reduce(
             (acc, obj) => {
              return (
                acc +
                  this.getNetCost(
                  obj.taxable_cost_in_minor_currency,
                  this.getTaxAmount(obj.tax)
                )
              );
            },
            0
          );
        } else return 0;
      })
    );
  }

  get baseCostRecurring$(): Observable<number> {
    return this.planBreakUpCalculationResponse$.pipe(
      map((value: PlanBreakUpCalculationResponse) => {
        if (value) {
          return value.plan_breakup_calculation.charging_recurring.services.reduce(
            (acc, obj) => {
              return (
                acc +
                this.getNetCost(
                  obj.base_cost_in_minor_currency,
                  this.getTaxAmount(obj.tax)
                )
              );
            },
            0
          );
        } else return 0;
      })
    );
  }

  get totalPayingAmount(): number {
    const value = this.planBreakUpCalculationResponse$.getValue();
    if (value) {
      let firstChargeCost = 0;
      let firstChargeTaxCost = 0;
      let nonRecurringChargeCost = 0;
      let nonRecurringTaxChargeCost = 0;
      let chargeCost = 0;
      let chargeTaxCost = 0;
      let depositCost = 0;
      let depositTaxCost = 0;

      if (value.plan_breakup_calculation) {
        const { charging_today } = value.plan_breakup_calculation;

        if (charging_today.service_first_charge.services) {
          firstChargeCost = charging_today.service_first_charge.services.reduce(
            (acc, obj) => acc + obj.taxable_cost_in_minor_currency,
            0
          );
          firstChargeTaxCost = this.getTotalTaxAmount(charging_today.service_first_charge.services);
        }

        if (charging_today.service_non_recurring.services) {
          nonRecurringChargeCost = charging_today.service_non_recurring.services.reduce(
            (acc, obj) => acc + obj.taxable_cost_in_minor_currency,
            0
          );
          nonRecurringTaxChargeCost = this.getTotalTaxAmount(charging_today.service_non_recurring.services);
        }

        chargeCost = charging_today.signup_charges.reduce(
          (acc, obj) => acc + obj.taxable_cost_in_minor_currency,
          0
        );
        chargeTaxCost = this.getTotalChargeTaxAmount(charging_today.signup_charges);

        if (charging_today.deposit) {
          charging_today.deposit.forEach(d => {
            depositCost += d.services.reduce(
              (acc, obj) => acc + obj.taxable_cost_in_minor_currency,
              0
            );
          });
          depositTaxCost = this.getTotalDepositTaxAmount(charging_today.deposit);
        }
      }

      const total = Math.round(
        firstChargeCost +
        firstChargeTaxCost +
        nonRecurringChargeCost +
        nonRecurringTaxChargeCost +
        chargeCost +
        chargeTaxCost +
        depositCost +
        depositTaxCost
      );

      return total;
    } else {
      return 0;
    }
  }

  get getAmountWithoutExternalChargeAmount(): number {
    const value = this.planBreakUpCalculationResponse$.getValue();
    if (value) {
      let firstChargeCost = 0;
      let firstChargeTaxCost = 0;
      let nonRecurringChargeCost = 0;
      let nonRecurringTaxChargeCost = 0;
      let chargeCost = 0;
      let chargeTaxCost = 0;
      let depositCost = 0;
      let depositTaxCost = 0;

      if (value.plan_breakup_calculation) {
        const { charging_today } = value.plan_breakup_calculation;

        if (charging_today.service_first_charge.services) {
          firstChargeCost = charging_today.service_first_charge.services.reduce(
            (acc, obj) => acc + obj.taxable_cost_in_minor_currency,
            0
          );
          firstChargeTaxCost = this.getTotalTaxAmount(charging_today.service_first_charge.services);
        }

        if (charging_today.service_non_recurring.services) {
          nonRecurringChargeCost = charging_today.service_non_recurring.services.reduce(
            (acc, obj) => acc + obj.taxable_cost_in_minor_currency,
            0
          );
          nonRecurringTaxChargeCost = this.getTotalTaxAmount(charging_today.service_non_recurring.services);
        }

        const charges = charging_today.signup_charges.filter(c => ! this.planSummary.subscriptionProductsAndCharges?.charges.some(cl => cl.charge_id === c.id));

        chargeCost = charges.reduce(
          (acc, obj) => acc + obj.taxable_cost_in_minor_currency,
          0
        );
        chargeTaxCost = this.getTotalChargeTaxAmount(charges);

        if (charging_today.deposit) {
          charging_today.deposit.forEach(d => {
            depositCost += d.services.reduce(
              (acc, obj) => acc + obj.taxable_cost_in_minor_currency,
              0
            );
          });
          depositTaxCost = this.getTotalDepositTaxAmount(charging_today.deposit);
        }
      }

      const total = Math.round(
        firstChargeCost +
        firstChargeTaxCost +
        nonRecurringChargeCost +
        nonRecurringTaxChargeCost +
        chargeCost +
        chargeTaxCost +
        depositCost +
        depositTaxCost
      );

      return total;
    } else {
      return 0;
    }
  }

  get totalOneTimeCost$(): Observable<number> {
    return this.planBreakUpCalculationResponse$.pipe(
      map((value: PlanBreakUpCalculationResponse) => {
        if (value) {
          let firstChargeCost: number = 0;
          let firstChargeTaxCost: number = 0;
          let nonRecurringChargeCost: number = 0;
          let nonRecurringTaxChargeCost: number = 0;
          let chargeCost: number = 0;
          let chargeTaxCost: number = 0;
          let depositCost: number = 0;
          let depositTaxCost: number = 0;
          let productCost: number = 0;
          let productTaxCost: number = 0;
          if (value && value.plan_breakup_calculation) {
            if (value.plan_breakup_calculation.charging_today.service_first_charge.services) {
              firstChargeCost =
                value.plan_breakup_calculation.charging_today.service_first_charge.services.reduce(
                  function (acc, obj) {
                    return acc + obj.taxable_cost_in_minor_currency;
                  },
                  0
                );
            }
            if (value.plan_breakup_calculation.charging_today.service_first_charge.services) {
              firstChargeTaxCost = this.getTotalTaxAmount(value.plan_breakup_calculation.charging_today.service_first_charge.services);
            }

            if(value.plan_breakup_calculation.charging_today.service_non_recurring.services)
              nonRecurringChargeCost = value.plan_breakup_calculation.charging_today.service_non_recurring.services.reduce(function (acc, obj) {
                return acc + obj.taxable_cost_in_minor_currency;
              }, 0);

            nonRecurringTaxChargeCost = this.getTotalTaxAmount(value.plan_breakup_calculation.charging_today.service_non_recurring.services);

            chargeCost = value.plan_breakup_calculation.charging_today.signup_charges.reduce(
              function (acc, obj) {
                return acc + obj.taxable_cost_in_minor_currency;
              },
              0
            );

            chargeTaxCost = this.getTotalChargeTaxAmount(value.plan_breakup_calculation.charging_today.signup_charges);

            if (value.plan_breakup_calculation.charging_today.deposit) {
              value.plan_breakup_calculation.charging_today.deposit.forEach(d => {
                depositCost = depositCost + d.services.reduce(
                  function (acc, obj) {
                    return acc + obj.taxable_cost_in_minor_currency;
                  },
                  0
                );
              });
              depositTaxCost = this.getTotalDepositTaxAmount(value.plan_breakup_calculation.charging_today.deposit ? value.plan_breakup_calculation.charging_today.deposit :[]);
            }
            if (value.plan_breakup_calculation.charging_today.products && value.plan_breakup_calculation.charging_today.products.length > 0) {
              productCost = value.plan_breakup_calculation.charging_today.products.reduce(
                function (acc, obj) {
                  return acc + obj.taxable_cost_in_minor_currency;
                },
                0
              );
              productTaxCost = this.getTotalProductTaxAmount(value.plan_breakup_calculation.charging_today.products);
            }
          }
          const total = Math.round(firstChargeCost +
            firstChargeTaxCost +
            nonRecurringChargeCost +
            nonRecurringTaxChargeCost +
            chargeCost +
            chargeTaxCost +
            depositCost +
            depositTaxCost +
            productCost +
            productTaxCost
          );

          return (total == 0) ? 0.00000000001 : total;
        } else return 0;
      })
    );
  }

  //#region firstTimeAmount
  get firstTimeAmountFormControl(): UntypedFormControl {
    return this.fgProducts.controls.frmFirstTimeAmt as UntypedFormControl;
  }

  get firstTimeAmount(): number {
    return this.firstTimeAmountFormControl.value as number;
  }

  set firstTimeAmount(val: number) {
    this.firstTimeAmountFormControl.setValue(val);
  }

  get firstTimeTaxAmountFormControl(): UntypedFormControl {
    return this.fgProducts.controls.frmFirstTimeTaxAmt as UntypedFormControl;
  }

  get firstTimeTaxAmount(): number {
    return this.firstTimeTaxAmountFormControl.value as number;
  }

  set firstTimeTaxAmount(val: number) {
    this.firstTimeTaxAmountFormControl.setValue(val);
  }

  get firstTimeDiscountFormControl(): UntypedFormControl {
    return this.fgProducts.controls.frmFirstTimeDis as UntypedFormControl;
  }

  get firstTimeDiscount(): number {
    return this.firstTimeDiscountFormControl.value as number;
  }

  set firstTimeDiscount(val: number) {
    this.firstTimeDiscountFormControl.setValue(val);
  }

  //#endregion firstTimeAmount

  //#region nonRecurringAmount

  get nonRecurringAmountFormControl(): UntypedFormControl {
    return this.fgProducts.controls.frmNonRecurringAmt as UntypedFormControl;
  }

  get nonRecurringAmount(): number {
    return this.nonRecurringAmountFormControl.value as number;
  }

  set nonRecurringAmount(val: number) {
    this.nonRecurringAmountFormControl.setValue(val);
  }

  get nonRecurringTaxAmountFormControl(): UntypedFormControl {
    return this.fgProducts.controls.frmNonRecurringTaxAmt as UntypedFormControl;
  }

  get nonRecurringTaxAmount(): number {
    return this.nonRecurringTaxAmountFormControl.value as number;
  }

  set nonRecurringTaxAmount(val: number) {
    this.nonRecurringTaxAmountFormControl.setValue(val);
  }

  get nonRecurringDiscountFormControl(): UntypedFormControl {
    return this.fgProducts.controls.frmNonRecurringDis as UntypedFormControl;
  }

  get nonRecurringDiscount(): number {
    return this.nonRecurringDiscountFormControl.value as number;
  }

  set nonRecurringDiscount(val: number) {
    this.nonRecurringDiscountFormControl.setValue(val);
  }

  //#endregion nonRecurringAmount

  //#region RecurringAmount

  get recurringMembershipBaseCostFormControl(): UntypedFormControl {
    return this.fgProductsRecurring.controls
      .frmRecurringMembershipBaseCostAmt as UntypedFormControl;
  }

  get recurringMembershipBaseCost(): number {
    return this.recurringMembershipBaseCostFormControl.value as number;
  }

  set recurringMembershipBaseCost(val: number) {
    this.recurringMembershipBaseCostFormControl.setValue(val);
  }

  get recurringMembershipFormControl(): UntypedFormControl {
    return this.fgProductsRecurring.controls
      .frmRecurringMembershipAmt as UntypedFormControl;
  }

  get recurringMembershipAmount(): number {
    return this.recurringMembershipFormControl.value as number;
  }

  set recurringMembershipAmount(val: number) {
    this.recurringMembershipFormControl.setValue(val);
  }

  get recurringMembershipDiscountFormControl(): UntypedFormControl {
    return this.fgProductsRecurring.controls
      .frmRecurringMembershipDis as UntypedFormControl;
  }

  get recurringMembershipDiscount(): number {
    return this.recurringMembershipDiscountFormControl.value as number;
  }

  set recurringMembershipDiscount(val: number) {
    this.recurringMembershipDiscountFormControl.setValue(val);
  }

  get recurringMembershipTaxAmountFormControl(): UntypedFormControl {
    return this.fgProductsRecurring.controls
      .frmRecurringMembershipTaxAmt as UntypedFormControl;
  }

  get recurringMembershipTaxAmount(): number {
    return this.recurringMembershipTaxAmountFormControl.value as number;
  }

  set recurringMembershipTaxAmount(val: number) {
    this.recurringMembershipTaxAmountFormControl.setValue(val);
  }

  get billingInterval(): number {
    return this.billing_interval_value$.value;
  }

  get biilingIntervalType(): string {
    return this.billing_interval_type$.value;
  }

  get ChargesDiscountReason(): UntypedFormControl {
    return this.fgProducts.controls.charges_reason as UntypedFormControl;
  }

  get RecurringDiscountReason(): UntypedFormControl {
    return this.fgProductsRecurring.controls.recurring_reason as UntypedFormControl;
  }

  //#endregion Cash

  get getInvalidCoupon(): boolean {
    return this.inValidCoupon.getValue();
  }

  get IsMinimumPaymentRequired(): boolean {
    return this.currentLoggedinUser && !(this.currentLoggedinUser.role.toLowerCase() == 'admin' || this.currentLoggedinUser.can_admin_billing == 'true')
  }

  get canByPassMaxSubscriptionStartDate(): boolean {
    return this.currentLoggedinUser && (this.currentLoggedinUser.role.toLowerCase() == 'admin' || this.currentLoggedinUser.can_admin_billing == 'true')
  }

  getTotalAmountInLocal(value: number) {
    return this.commonService.ConvertAmountFromMinorCurrency(value);
  }

  getTotalAmountInCurrency() {
    let totalAmount = 0;
    this.totalOneTimeCost$.subscribe({
      next: (amount: number) => {
        totalAmount = this.commonService.ConvertAmountFromMinorCurrency(amount);
      }
    });
    return totalAmount;
  }

  timeout(ms: any) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  formatDate(date: Date) {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [year, month, day].join('-');
  }


  HideErrorPopup() {
    this.errorMessages = [];
    this.errorDataModal = [];
    if (this.errorOnCouponApply) {
      this.bindPlanBreakUp(this.tenantId, this.subscriptionPlanId, this.clientId);
      this.errorOnCouponApply = false;
    }
    this.showErrorPopup?.next(false);
  }

  GetErrorData(event: any) {
    this.errorMessages = event.errors;
    this.showErrorPopup?.next(event.showErrors);
  }

  get ShowErrorPopup(): Observable<boolean> {
    return this.showErrorPopup?.asObservable() || of(false);
  }

  getInterval(
    billing_interval_value: number,
    billing_interval_type: PlanIntervalType
  ) {
    let str: string = '';
    if (
      billing_interval_type == PlanIntervalType.Month ||
      billing_interval_type?.toString() ==
      PlanIntervalType[PlanIntervalType.Month]
    ) {
      if (billing_interval_value > 1) str = 'months';
      else str = 'month';
    } else if (
      billing_interval_type == PlanIntervalType.Week ||
      billing_interval_type.toString() == PlanIntervalType[PlanIntervalType.Week]
    ) {
      if (billing_interval_value > 1) str = 'weeks';
      else str = 'week';
    }
    else if (
      billing_interval_type == PlanIntervalType.Day ||
      billing_interval_type == PlanIntervalType[PlanIntervalType.Day]
    ) {
      if (billing_interval_value > 1) str = 'days';
      else str = 'day';
    }
    return str.toUpperCase();
  }

  isTypeContract(subscription_category: any): boolean {
    if (
      subscription_category == PlanCategory.DropIn ||
      subscription_category.toString() == PlanCategory[PlanCategory.DropIn] ||
      subscription_category == PlanCategory.PaidInFull ||
      subscription_category.toString() == PlanCategory[PlanCategory.PaidInFull]
    ) {
      return false;
    } else {
      return true;
    }
  }

  clientStatus(client: any): string {
    if (client && client.client_status)
      return this.clientService.getClientStatusHtml(
        client.client_status.toString()
      );
    else return '';
  }

  filterStaff() {
    let claim: Claim[] = {} as Claim[];
    let staffs: STAFFINTERFACE[] = [];
    const validStaff: number[] = [];
    this.claim$.pipe(combineLatestWith(this.store.select(STAFF_STATE)))
      .subscribe(([objClaim, objStaff]) => {
        claim = objClaim;
        staffs = objStaff.staffList;

        if (staffs.length > 0) {
          staffs.forEach((stf) => {
            if (
              stf.role == Roles.Admin ||
              stf.role.toString() == Roles[Roles.Admin] ||
              stf.role == Roles.FFAdmin ||
              stf.role.toString() == Roles[Roles.FFAdmin] ||
              claim.filter(
                (o) =>
                  o.id == stf.claim_template_id &&
                  (o.can_admin_billing == true || o.can_do_billing == true)
              ).length > 0
            )
              validStaff.push(stf.id);
          });
          this._filterStaff.next(validStaff);
        }
      });
  }

  ordinalNumber(n: number | null | undefined): string {
    if (n) {
      const s = ['th', 'st', 'nd', 'rd'];
      const v: number = n % 100;
      return (
        n.toString() +
        '<sup>' +
        (s[(v - 20) % 10] || s[v] || s[0]).toString() +
        '</sup> '
      );
    } else return '';
  }

  ordinalNumberNew(date: any): string {
    const localdate = new Date(date);
    const day = this.ordinalNumber(localdate.getDate());
    return day;
  }

  monthName(data: Date): string {
    return this.monthNames[new Date(data).getMonth()];
  }

  getSessionOwnerFC(ctlName: string): AbstractControl | null {
    return this.fg.get(ctlName);
  }

  getAddonEndDate(addOn: PlanAddons) {
    const chargingTodayAddons = this.billingSignupMode === SignUpMode.MidCycleAddons
      ? this.midCycleAddonBreakUpCalculationResponse$.value?.charging_today_addons?.non_recurring_addons
      : this.planBreakUpCalculationResponse$.value?.plan_breakup_calculation?.charging_today?.service_non_recurring?.services;

    const addonEndDate = chargingTodayAddons?.find(o => o.category_id == addOn.category_id && o.id == addOn.id)?.end_date;

    return addonEndDate || new Date();
  }

  isExplimentoryMarkShow(): boolean {
    const depositOccurrence = this.billingSignupMode === SignUpMode.MidCycleAddons
      ? this.fromSubscription.deposit_occurence
      : this.planDetail.deposit_occurence;

    const subscriptionCategory = this.billingSignupMode === SignUpMode.MidCycleAddons
      ? this.fromSubscription.subscription_category
      : this.planDetail.subscription_category;

    return depositOccurrence && depositOccurrence.length > 0 && this.isPlanBehaviourRecurring(subscriptionCategory.toString());
  }

  async removeAddon(addOn: PlanAddons) {
    this.tableLoading.next(true);
    const addOns = this.selectedAddons.value;
    const index = addOns.indexOf(addOns.filter(o => o.category_id == addOn.category_id && o.id == addOn.id)[0]);
    addOns.splice(index, 1);
    this.selectedAddons.next(addOns);
    this.bindPlanBreakUp(this.tenantId, this.subscriptionPlanId, this.clientId);
  }

  get hasbillingRights(): boolean {
    return (
      this.currentUserDetails.role.toLowerCase() == 'admin' ||
      this.currentUserDetails.role == Roles.Admin ||
      this.currentUserDetails.role.toString() == Roles[Roles.Admin] ||
      this.currentUserDetails.can_do_billing === 'true'
    );
  }

  RequestAccess() {
    const reportRequestAccess = {
      claim: ClaimConstant.can_admin_billing,
      access_requested_friendly_name: ClaimConstant.can_admin_billing,
      request_access_comment: 'Claim Acess for Billing',
    };

    this.claimService.RequestAccess(this.tenantId, reportRequestAccess).subscribe({
      next: () => {
        this.showPaidFullSidebar = false;
        this.closeBillingSideBar('');
        this.translate
          .get('STAFF.ACCESS.REQUEST_SUCCESS')
          .subscribe((translation) => {
            this.toastMessageService.showSuccess(translation);
          });
      },
      error: (error) => {
        if (error instanceof NotFoundError) {
          this.translate
            .get('REPORTS.ERROR_MSG.ERROR')
            .subscribe((translation) => {
              this.toastMessageService.showErrorMessage(translation);
            });
        } else {
          this.translate
            .get('STAFF.ACCESS.REQUEST_FAILED')
            .subscribe((translation) => {
              this.toastMessageService.showErrorMessage(translation);
            });
        }
        this.showPaidFullSidebar = false;
        this.closeBillingSideBar('');
      },
    });
  }

  showSessionOwnerButon(getPlanMasterByIdResponse: GetPlanMasterByIdResponse) {
    if (getPlanMasterByIdResponse.recurring_services) {
      getPlanMasterByIdResponse.recurring_services.forEach((element) => {
        if (element.behaviour == ServiceBehaviour.AppointmentPackage || element.behaviour.toString() == ServiceBehaviour[ServiceBehaviour.AppointmentPackage])
          this.boolshowSessionOwner = true;
      });
    }

    if (getPlanMasterByIdResponse.non_recurring_services) {
      getPlanMasterByIdResponse.non_recurring_services.forEach((element) => {
        if (element.behaviour == ServiceBehaviour.AppointmentPackage || element.behaviour.toString() == ServiceBehaviour[ServiceBehaviour.AppointmentPackage])
          this.boolshowSessionOwner = true;
      });
    }
  }

  showSessionOwnerModel() {
    this.showSessionOwnerChangeModel$.next(true);
  }

  getControls(controlName: string) {
    const ChargeControls = this.fgProducts.controls.charges as any;
    return ChargeControls.controls[0].get(controlName) as UntypedFormControl;
  }

  getDepositControls(controlName: string) {
    const depositControls = this.fgProducts.controls.deposits as any;
    return depositControls.controls[0].get(controlName) as UntypedFormControl;
  }

  getProductControls(controlName: string) {
    const productControls = this.fgProducts.controls.products as any;
    if (productControls && productControls.controls && productControls.controls.length > 0) {
      return productControls.controls[0].get(controlName) as UntypedFormControl;
    }
    return null;
  }

  generateDepositOccurence(deposit: Deposit[]): { id: number, occurenceName: string; amount: number }[] {
    const result: { id: number, occurenceName: string; amount: number }[] = [];
    const getKey = (i: number, suffix: string): string => `${i}${suffix}`;
    const getLastKey = (i: number, suffix: string): string => `${i}${suffix}`;
    deposit.forEach((deposit, index) => {
      if (deposit.deposit_occurence > 0) {
        const key = getKey(deposit.deposit_occurence, deposit.deposit_occurence <= 3 ? ['st', 'nd', 'rd'][deposit.deposit_occurence - 1] : 'th');
        this.translate.get('POS.MEMBERSHIP_ADDON.OCCURENCE', { suffix: key, count: index + 1 })
          .subscribe((translation) => {
            result.push({ id: deposit.deposit_internal_id, occurenceName: translation, amount: this.getDepositServiceAmount(deposit) });
          });
      } else if (deposit.deposit_occurence < 0) {
        const absValue = Math.abs(deposit.deposit_occurence);
        const key = getKey(absValue, absValue <= 3 ? ['st', 'nd', 'rd'][absValue - 1] : 'th');
        this.translate.get('POS.MEMBERSHIP_ADDON.LAST_OCCURENCE', { suffix: key, count: index + 1 })
          .subscribe((translation) => {
            result.push({ id: deposit.deposit_internal_id, occurenceName: translation, amount: this.getDepositServiceAmount(deposit)  });
          });
      } else {
        this.translate.get('POS.MEMBERSHIP_ADDON.DEPOSIT', { count: index + 1 })
          .subscribe((translation) => {
            result.push({ id: deposit.deposit_internal_id, occurenceName: translation, amount: this.getDepositServiceAmount(deposit)  });
          });
      }
    });
    return result;
  }

  getDepositServiceAmount(deposit: Deposit) {
    if (deposit) {
      return deposit.services.reduce(
        (acc, obj) => {
          return (
            acc + obj.taxable_cost_in_minor_currency + (this.isInclusive ? this.getTaxAmount(obj.tax) : 0) 
          )
        },
        0
      );
    } else return 0;
  }


  get isPayingTodayZero(): boolean {
    return this.totalPayingAmount === 0;
  }

  get isRecurringAmountNotZero() {
   return this.recurringTotalAmount$ > 0;
  }


  trackByFn(index: any, item: any) {
    return index;
  }

  trackByProductId(index: number, item: any): number {
    return item.sku_id || index;
  }

  trackByChargeId(index: number, item: any): number {
    return item.charge_id || index;
  }


  public get signUpMode() {
    return SignUpMode;
  }
}
